import React, { useEffect, useState, useRef, useMemo } from "react";

import api from "../../services/api";
import validadorCpfCnpj from "../../services/validadorCpfCnpj";

import { store } from "react-notifications-component";
import buscaCep from "../../services/buscaCep";

import HeaderV2 from "../../components/headerV2";
import FilterV2 from "../../components/filterV2";
import MapaArea from "../../components/mapaArea";
import InputSign from "../../components/inputSign";
import Input from "../../components/input/input_v2";
import Modal from "../../components/modal/modalGenericV2";
import ModalYesNo from "../../components/modal/modalYesNo";
import InputV3 from "../../components/input/novo/input_v3";

import Tooltip from "../../components/tooltip";

import mais from "../../assets/Mais.png";
import plus from "../../assets/icons/plus.png";
import local from "../../assets/icons/icon-pin-blue.png";
import IconZap from "../../assets/icons/icon-whatsapp-gray.png";
import IconEmail from "../../assets/icons/icon-mail-gray.png";
import IconMap from "../../assets/icons/icon-pin-gray.png";
import IconPhone from "../../assets/icons/icon-phone-gray.png";
import { IconUploads } from "../../assets/icons/iconUploads";
import ItemNotFound from "../../assets/img-undraw-search.svg";
import Filter from "../../assets/icons/icon-Tune.png";
import ModalBlock from "../../components/modal/modalFuncaoBloqueadaImpressaoFe";
import { openCulturaUrl } from "../../utils/culturasPdf";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import moment from "moment";
import "../agenda/lib/react-big-calendar.css";
import "../agenda/lib/style.css";

import * as S from "./styles";
import { theme } from "../../styles/theme";
import {
  Auxiliar,
  BodyM,
  BodyP,
  H6,
  TaglineM,
  TaglineP,
} from "../../styles/stylesTypography";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";
import ModalCreateOrEditEvent from "../../components/modalCreateOrEditEvent";

export const USER = "@userinfo";
export const USERJSON = JSON.parse(localStorage.getItem(USER));

const localizer = momentLocalizer(moment);

export default function NovoCalendario() {
  const [showNewEvent, setShowNewEvent] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [activeFilter, setActiveFilter] = useState("agenda");

  const [onlyOption, setOnlyOption] = useState({
    agronomist: false,
    producer: false,
    farm: false,
  });

  const [titleDrawer, setTitleDrawer] = useState("");
  const [descriptionDrawer, setDescriptionDrawer] = useState("");
  const [agronomistDrawer, setAgronomistDrawer] = useState({
    value: null,
    label: "",
  });
  const [producerDrawer, setProducerDrawer] = useState({
    value: null,
    label: "",
  });
  const [cultureDrawer, setCultureDrawer] = useState({
    value: null,
    label: "",
  });
  const [startDateDrawer, setStartDateDrawer] = useState("");
  const [endDateDrawer, setEndDateDrawer] = useState("");
  const [statusDrawer, setStatusDrawer] = useState({ value: null, label: "" });

  const [agronomists, setAgronomists] = useState([]);
  const [producers, setProducers] = useState([]);
  const [agroFarmsDrawer, setAgroFarmsDrawer] = useState({
    value: null,
    label: "",
  });
  const [agroFarms, setAgroFarms] = useState([]);
  const [cultures, setCultures] = useState([]);

  const [isFarmDisabled, setIsFarmDisabled] = useState(true);
  const [isButtonFarmDisabled, setIsButtonFarmDisabled] = useState(true);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingResume, setIsLoadingResume] = useState(true);

  // Estados para controle de erros
  const [titleError, setTitleError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [agronomistError, setAgronomistError] = useState(false);
  const [producerError, setProducerError] = useState(false);
  const [farmError, setFarmError] = useState(false);
  const [cultureError, setCultureError] = useState(false);
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [statusError, setStatusError] = useState(false);

  // Refs - Drawer
  const selectAgronomistRef = useRef(null);
  const selectProducerRef = useRef(null);
  const selectAgroFarmsRef = useRef(null);
  const selectCultureRef = useRef(null);
  const selectStatusRef = useRef(null);
  const openedByParamRef = useRef(false);

  const isMobileDevice = () => /android|iphone|ipad|ipod|windows phone/i.test((navigator.userAgent || "").toLowerCase());

  const getMapLink = (item) => {
    const farm = item.agro_farms || {};
    const hasCoords = farm.latitude != null && farm.longitude != null && farm.latitude !== '' && farm.longitude !== '';
    const hasAddress = !!farm.endereco;

    if (!hasCoords && !hasAddress) return { href: null, disabled: true };

    const q = hasCoords
      ? `${farm.latitude},${farm.longitude}`
      : [farm.endereco, farm.numero, farm.bairro, farm.cidade, farm.estado, farm.cep].filter(Boolean).join(', ');

    const href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

    return { href, disabled: false };
  };

  //Filtro de pesquisa
  const [search, setSearch] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");

  //Modal
  const [showAddAgronomist, setShowAddAgronomist] = useState(false);
  const [showAddProducer, setShowAddProducer] = useState(false);
  const [showAddFarm, setShowAddFarm] = useState(false);

  const [currentId, setCurrentId] = useState(0);

  //Modal Add Agronomo
  const [nameAgronomist, setNameAgronomist] = useState("");
  const [emailAgronomist, setEmailAgronomist] = useState("");
  const [cpfAgronomist, setCpfAgronomist] = useState("");
  const [whatsappAgronomist, setWhatsappAgronomist] = useState("");

  const [isLoadingSavedAgronomist, setIsLoadingSavedAgronomist] =
    useState(false);

  const [hasErrorAgronomist, setHasErrorAgronomist] = useState({
    name: false,
    email: false,
    cpf: false,
    whatsapp: false,
  });
  const [cpfAgronomistErrorMsg, setCpfAgronomistErrorMsg] = useState('');

  //Modal de adicionar responsável técnico
  const [eletronica, setEletronica] = useState(false);
  const [digital, setDigital] = useState(false);
  const [manual, setManual] = useState(false);
  const [estadosDigital, setEstadosDigital] = useState([]);
  const [excecoesEletronica, setExcecoesEletronica] = useState([]);

  const [namesfiles, setNamesfiles] = useState([]);
  const [assinatura, setAssinatura] = useState("");

  const [renderInput, setRenderInput] = useState(false);
  const [isValidate, setIsValidate] = useState(false);

  const [file, setFile] = useState("");
  const [textFile, setTextFile] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalBlock, setShowModalBlock] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);

  const [cpf, setCpf] = useState("");

  //Modal Add Produtor
  const [idProducer, setIdProducer] = useState(0);

  const [nameProducer, setNameProducer] = useState("");
  const [emailProducer, setEmailProducer] = useState("");
  const [cpfCnpjProducer, setCpfCnpjProducer] = useState("");
  const [telephoneProducer, setTelephoneProducer] = useState("");
  const [cellphoneProducer, setCellphoneProducer] = useState("");
  const [cepProducer, setCepProducer] = useState("");
  const [logradouroProducer, setLogradouroProducer] = useState("");
  const [bairroProducer, setBairroProducer] = useState("");
  const [numberProducer, setNumberProducer] = useState("");
  const [complementProducer, setComplementProducer] = useState("");
  const [cityProducer, setCityProducer] = useState("");
  const [stateProducer, setStateProducer] = useState({
    value: null,
    label: "",
  });
  const selectStateProducerRef = useRef(null);
  const [openModalTrue, setOpenModalTrue] = useState(false);

  const stateOptions = [
    { value: "AC", label: "Acre" },
    { value: "AL", label: "Alagoas" },
    { value: "AP", label: "Amapá" },
    { value: "AM", label: "Amazonas" },
    { value: "BA", label: "Bahia" },
    { value: "CE", label: "Ceará" },
    { value: "DF", label: "Distrito Federal" },
    { value: "ES", label: "Espírito Santo" },
    { value: "GO", label: "Goiás" },
    { value: "MA", label: "Maranhão" },
    { value: "MT", label: "Mato Grosso" },
    { value: "MS", label: "Mato Grosso do Sul" },
    { value: "MG", label: "Minas Gerais" },
    { value: "PA", label: "Pará" },
    { value: "PB", label: "Paraiba" },
    { value: "PR", label: "Paraná" },
    { value: "PE", label: "Pernambuco" },
    { value: "PI", label: "Piauí" },
    { value: "RJ", label: "Rio de Janeiro" },
    { value: "RN", label: "Rio Grande do Norte" },
    { value: "RS", label: "Rio Grande do Sul" },
    { value: "RO", label: "Rondônia" },
    { value: "RR", label: "Roraima" },
    { value: "SC", label: "Santa Catarina" },
    { value: "SP", label: "São Paulo" },
    { value: "SE", label: "Sergipe" },
    { value: "TO", label: "Tocantins" },
  ];

  const [isLoadingSavedProducer, setIsLoadingSavedProducer] = useState(false);

  const [hasErrorProducer, setHasErrorProducer] = useState({
    nameProducer: false,
    emailProducer: false,
    cpfCnpjProducer: false,
    telephoneProducer: false,
    cellphoneProducer: false,
    cepProducer: false,
    logradouroProducer: false,
    bairroProducer: false,
    numberProducer: false,
    complementProducer: false,
    cityProducer: false,
    stateProducer: false,
  });
  const [cpfCnpjProducerErrorMsg, setCpfCnpjProducerErrorMsg] = useState('');

  //Modal Add Farm
  const [nameFarm, setNameFarm] = useState("");
  const [cpfCnpjFarm, setCpfCnpjFarm] = useState("");
  const [registrationStateFarm, setRegistrationStateFarm] = useState("");
  const [cepFarm, setCepFarm] = useState("");
  const [logradouroFarm, setLogradouroFarm] = useState("");
  const [bairroFarm, setBairroFarm] = useState("");
  const [numberFarm, setNumberFarm] = useState("");
  const [complementFarm, setComplementFarm] = useState("");
  const [codeIbgeFarm, setCodeIbgeFarm] = useState("");
  const [cityFarm, setCityFarm] = useState("");

  const selectStateFarmRef = useRef(null);
  const [stateFarm, setStateFarm] = useState({
    value: null,
    label: "",
  });

  const [
    producersRegistrationNumberAgencyFarm,
    setProducersRegistrationNumberAgencyFarm,
  ] = useState("");
  const [totalAreaFarm, setTotalAreaFarm] = useState("");
  const [culturesFarm, setCulturesFarm] = useState("");
  const [registrationAmbientFarm, setRegistrationAmbientFarm] = useState("");

  const selectCoordinatesFarmRef = useRef(null);
  const [optionsCoordinatesFarm, setOptionsCoordinatesFarm] = useState({
    value: 0,
    label: "",
  });

  const [latitudeFarm, setLatitudeFarm] = useState("");
  const [longitudeFarm, setLongitudeFarm] = useState("");
  const [altitudeFarm, setAltitudeFarm] = useState("");

  const [modoCoord, setModoCoord] = useState(0);
  const [showMapa, setShowMapa] = useState(false);
  const [showInputs, setShowInputs] = useState(false);
  const [estadoLocal, setEstadoLocal] = useState("");
  const [estadosObrigatorios, setEstadosObrigatorios] = useState([]);

  const [latitudeGraus, setLatitudeGraus] = useState("");
  const [latitudeMinutos, setLatitudeMinutos] = useState("");
  const [latitudeSegundos, setLatitudeSegundos] = useState("");

  const [longitudeGraus, setLongitudeGraus] = useState("");
  const [longitudeMinutos, setLongitudeMinutos] = useState("");
  const [longitudeSegundos, setLongitudeSegundos] = useState("");

  const [erroLatitude, setErroLatitude] = useState(false);
  const [erroLongitude, setErroLongitude] = useState(false);

  const [hasErrorFarm, setHasErrorFarm] = useState({
    nameFarm: false,
    cpfCnpjFarm: false,
    registrationStateFarm: false,
    cepFarm: false,
    logradouroFarm: false,
    bairroFarm: false,
    numberFarm: false,
    complementFarm: false,
    codeIbgeFarm: false,
    cityFarm: false,
    stateFarm: false,
    geographicCoordinate: false,
  });
  const [cpfCnpjFarmErrorMsg, setCpfCnpjFarmErrorMsg] = useState('');

  const [isLoadingSavedFarm, setIsLoadingSavedFarm] = useState(false);

  const [consult, setConsult] = useState([]);

  const isEstadoObrigatorio = (estado) =>
    estadosObrigatorios.includes(estado);

  const changeCoordinates = (lat, lng) => {
    setLatitudeFarm(`${lat}`);
    setLongitudeFarm(`${lng}`);
  };

  const validateLatitude = async (tipo, valor) => {
    setErroLatitude(false);
    if (tipo === 1) {
      if (latitudeGraus.length > valor.length) {
        if (valor.length === 3) {
          let separa = valor.split("");
          if (separa[2] === ".") {
            setLatitudeGraus(`${separa[0]}${separa[1]}`);
          } else {
            setLatitudeGraus(valor);
          }
        } else {
          setLatitudeGraus(valor);
        }
      } else {
        if (valor.length === 3) {
          let separa = valor.split("");
          if (separa[2] === ".") {
            setLatitudeGraus(valor);
          } else {
            if (separa[2] === ",") {
              setLatitudeGraus(`${separa[0]}${separa[1]}.`);
            } else {
              setLatitudeGraus(`${separa[0]}${separa[1]}.${separa[2]}`);
            }
          }
        } else {
          setLatitudeGraus(valor);
        }
      }
    } else if (tipo === 2) {
      if (latitudeMinutos.length > valor.length) {
        if (valor.length === 3) {
          let separa = valor.split("");
          if (separa[2] === ".") {
            setLatitudeMinutos(`${separa[0]}${separa[1]}`);
          } else {
            setLatitudeMinutos(valor);
          }
        } else {
          setLatitudeMinutos(valor);
        }
      } else {
        if (valor.length === 3) {
          let separa = valor.split("");
          if (separa[2] === ".") {
            setLatitudeMinutos(valor);
          } else {
            if (separa[2] === ",") {
              setLatitudeMinutos(`${separa[0]}${separa[1]}.`);
            } else {
              setLatitudeMinutos(`${separa[0]}${separa[1]}.${separa[2]}`);
            }
          }
        } else {
          setLatitudeMinutos(valor);
        }
      }
    } else if (tipo === 3) {
      if (latitudeSegundos.length > valor.length) {
        if (valor.length === 3) {
          let separa = valor.split("");
          if (separa[2] === ".") {
            setLatitudeSegundos(`${separa[0]}${separa[1]}`);
          } else {
            setLatitudeSegundos(valor);
          }
        } else {
          setLatitudeSegundos(valor);
        }
      } else {
        if (valor.length === 3) {
          let separa = valor.split("");
          if (separa[2] === ".") {
            setLatitudeSegundos(valor);
          } else {
            if (separa[2] === ",") {
              setLatitudeSegundos(`${separa[0]}${separa[1]}.`);
            } else {
              setLatitudeSegundos(`${separa[0]}${separa[1]}.${separa[2]}`);
            }
          }
        } else {
          setLatitudeSegundos(valor);
        }
      }
    }

    if (latitudeGraus && latitudeMinutos && latitudeSegundos) {
      if (tipo === 3) {
        setLatitudeFarm(`${latitudeGraus}°${latitudeMinutos}'${valor}"S`);
      } else {
        setLatitudeFarm(
          `${latitudeGraus}°${latitudeMinutos}'${latitudeSegundos}"S`
        );
      }
    }
  };

  const validateLongitude = async (tipo, valor) => {
    setErroLongitude(false);
    if (tipo === 1) {
      if (longitudeGraus.length > valor.length) {
        if (valor.length === 3) {
          let separa = valor.split("");
          if (separa[2] === ".") {
            setLongitudeGraus(`${separa[0]}${separa[1]}`);
          } else {
            setLongitudeGraus(valor);
          }
        } else {
          setLongitudeGraus(valor);
        }
      } else {
        if (valor.length === 3) {
          let separa = valor.split("");
          if (separa[2] === ".") {
            setLongitudeGraus(valor);
          } else {
            if (separa[2] === ",") {
              setLongitudeGraus(`${separa[0]}${separa[1]}.`);
            } else {
              setLongitudeGraus(`${separa[0]}${separa[1]}.${separa[2]}`);
            }
          }
        } else {
          setLongitudeGraus(valor);
        }
      }
    } else if (tipo === 2) {
      if (longitudeMinutos.length > valor.length) {
        if (valor.length === 3) {
          let separa = valor.split("");
          if (separa[2] === ".") {
            setLongitudeMinutos(`${separa[0]}${separa[1]}`);
          } else {
            setLongitudeMinutos(valor);
          }
        } else {
          setLongitudeMinutos(valor);
        }
      } else {
        if (valor.length === 3) {
          let separa = valor.split("");
          if (separa[2] === ".") {
            setLongitudeMinutos(valor);
          } else {
            if (separa[2] === ",") {
              setLongitudeMinutos(`${separa[0]}${separa[1]}.`);
            } else {
              setLongitudeMinutos(`${separa[0]}${separa[1]}.${separa[2]}`);
            }
          }
        } else {
          setLongitudeMinutos(valor);
        }
      }
    } else if (tipo === 3) {
      if (longitudeSegundos.length > valor.length) {
        if (valor.length === 3) {
          let separa = valor.split("");
          if (separa[2] === ".") {
            setLongitudeSegundos(`${separa[0]}${separa[1]}`);
          } else {
            setLongitudeSegundos(valor);
          }
        } else {
          setLongitudeSegundos(valor);
        }
      } else {
        if (valor.length === 3) {
          let separa = valor.split("");
          if (separa[2] === ".") {
            setLongitudeSegundos(valor);
          } else {
            if (separa[2] === ",") {
              setLongitudeSegundos(`${separa[0]}${separa[1]}.`);
            } else {
              setLongitudeSegundos(`${separa[0]}${separa[1]}.${separa[2]}`);
            }
          }
        } else {
          setLongitudeSegundos(valor);
        }
      }
    }

    if (longitudeGraus && longitudeMinutos && longitudeSegundos) {
      if (tipo === 3) {
        setLongitudeFarm(`${longitudeGraus}°${longitudeMinutos}'${valor}"W`);
      } else {
        setLongitudeFarm(
          `${longitudeGraus}°${longitudeMinutos}'${longitudeSegundos}"W`
        );
      }
    }
  };

  const changeModoCoord = (e) => {
    const newValue = parseInt(e);

    setModoCoord(newValue);

    if (newValue === 2) {
      setShowMapa(false);
      setShowInputs(true);
    } else {
      setShowMapa(true);
      setShowInputs(false);
    }
  };

  useEffect(() => {
    if (modoCoord === 1) {
      setShowMapa(true);
    } else if (modoCoord === 2) {
      setShowInputs(true);
    }
  }, [modoCoord]);

  const formatarData = (dataISO) => {
    const mesesAbreviados = [
      "JAN",
      "FEV",
      "MAR",
      "ABR",
      "MAI",
      "JUN",
      "JUL",
      "AGO",
      "SET",
      "OUT",
      "NOV",
      "DEZ",
    ];

    const data = new Date(dataISO);
    const dia = data.getUTCDate();
    const mes = mesesAbreviados[data.getUTCMonth()];
    const ano = data.getUTCFullYear();

    return `${dia} ${mes} ${ano}`;
  };

  const formatarDataParaAPI = (dataLocal) => {
    if (!dataLocal) return "";
    const date = new Date(dataLocal);

    const offset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - offset).toISOString();
  };

  const requestGeolocation = () => new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      reject({ code: 'NOT_SUPPORTED' });
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => resolve({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy,
      }),
      (error) => reject(error),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  });

  const tryGetGeolocation = async () => {
    try {
      const coords = await requestGeolocation();
      return coords;
    } catch (err) {
      let message = null;
      if (err?.code === 1) message = identifyErrorMenssage(err, "Permissão de localização negada. O evento será criado sem coordenadas.");
      else if (err?.code === 2) message = identifyErrorMenssage(err, "Localização indisponível no momento. O evento será criado sem coordenadas.");
      else if (err?.code === 3) message = identifyErrorMenssage(err, "Tempo esgotado ao obter localização. O evento será criado sem coordenadas.");
      else if (err?.code === 'NOT_SUPPORTED') message = identifyErrorMenssage(err, "Geolocalização não suportada neste dispositivo/navegador.");
      if (message) {
        store.addNotification({
          title: "Atenção",
          message,
          type: "warning",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true },
        });
      }
      return null;
    }
  };

  const requestGeolocationOnCreate = () => {
    tryGetGeolocation()
      .then((c) => {
        setUserCoords(c);
        if (c && c.latitude != null && c.longitude != null) {
          store.addNotification({
            title: "Localização registrada",
            message: `Coordenadas capturadas: ${typeof c.latitude === 'number' ? c.latitude.toFixed(6) : c.latitude}, ${typeof c.longitude === 'number' ? c.longitude.toFixed(6) : c.longitude}`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 4000, onScreen: true },
          });
        }
      })
      .catch(() => setUserCoords(null));
  };

  const getUserFromStorage = () => {
    try {
      return JSON.parse(localStorage.getItem(USER) || "null");
    } catch (_) {
      return null;
    }
  };

  const isCreateEventBlocked = () => {
    const user = getUserFromStorage();
    const planId = user?.contrato?.agro_plan_config?.agro_plan_id;
    const diasRestante = Number(user?.contrato?.dias_restante ?? 0);
    // 5 = plano com Caderno de Campo nativo; 9/10/11 = Protheus/SIAC/Omie
    // (integrações TOTVS/Omie) - também liberados pra criar evento.
    const planosComCadernoCampo = [5, 9, 10, 11];

    return !planosComCadernoCampo.includes(planId) || (planId === 1 && diasRestante > 0);
  };

  const openNewEventDrawer = (e) => {
    if (isCreateEventBlocked()) {
      if (e && typeof e.preventDefault === "function") {
        e.preventDefault();
      }
      if (e && typeof e.stopPropagation === "function") {
        e.stopPropagation();
      }
      setTimeout(() => setOpenModalTrue(true), 0);
      return;
    }

    setShowNewEvent(true);
  };

  const handleCreateEventClick = (e) => {
    if (isCreateEventBlocked()) {
      if (e && typeof e.preventDefault === "function") {
        e.preventDefault();
      }
      if (e && typeof e.stopPropagation === "function") {
        e.stopPropagation();
      }
      setTimeout(() => setOpenModalTrue(true), 0);
      return;
    }

    requestGeolocationOnCreate();
    setShowNewEvent(true);
  };

  const formatDateTimeLocalInput = (dateObj) => {
    if (!dateObj) return "";
    const d = new Date(dateObj);
    const pad = (n) => String(n).padStart(2, "0");
    const y = d.getFullYear();
    const m = pad(d.getMonth() + 1);
    const day = pad(d.getDate());
    const hh = pad(d.getHours());
    const mm = pad(d.getMinutes());
    return `${y}-${m}-${day}T${hh}:${mm}`;
  };

  const parseUTCToLocalWallTime = (isoString) => {
    if (!isoString) return null;
    const m = moment.utc(isoString);
    return new Date(
      m.year(),
      m.month(),
      m.date(),
      m.hour(),
      m.minute(),
      m.second(),
      m.millisecond()
    );
  };

  const calendarEvents = useMemo(() => {
    const data = consult?.data || [];
    return data
      .filter((a) => a?.date_begin && a?.date_end)
      .map((a) => ({
        id: a.id || a.schedule_id,
        title: a.title,
        start: parseUTCToLocalWallTime(a.date_begin),
        end: parseUTCToLocalWallTime(a.date_end),
        resource: a,
      }));
  }, [consult]);

  // Formatos do calendário: capitaliza nomes de dias e meses
  const calendarFormats = useMemo(
    () => ({
      // Mês (cabeçalho dos dias)
      weekdayFormat: (date, culture, loc) => {
        const s = loc.format(date, "ddd", culture); // dom, seg, ter, qua, qui, sex, sáb
        return s.charAt(0).toUpperCase() + s.slice(1); // Dom, Seg, Ter, Qua, Qui, Sex, Sáb
      },
      // Mês (título da toolbar, ex: "Novembro 2025")
      monthHeaderFormat: (date, culture, loc) => {
        const m = loc.format(date, "MMMM", culture);
        const mCap = m.charAt(0).toUpperCase() + m.slice(1);
        const y = loc.format(date, "YYYY", culture);
        return `${mCap} ${y}`;
      },
      // Semana (cabeçalhos das colunas, ex: "02 dom")
      dayFormat: (date, culture, loc) => {
        const d = loc.format(date, "DD", culture);
        const w = loc.format(date, "ddd", culture);
        const wCap = w.charAt(0).toUpperCase() + w.slice(1);
        return `${d} ${wCap}`; // 02 Dom
      },
      // Dia (cabeçalho principal do dia, ex: "Sex 07 novembro")
      dayHeaderFormat: (date, culture, loc) => {
        const w = loc.format(date, "dddd", culture); // sexta-feira
        const wCap = w.charAt(0).toUpperCase() + w.slice(1); // Sexta-feira
        const d = loc.format(date, "DD", culture);
        const m = loc.format(date, "MMMM", culture);
        const mCap = m.charAt(0).toUpperCase() + m.slice(1);
        return `${wCap} ${d} ${mCap}`;
      },
      // Semana (título da toolbar com intervalo, ex: "Novembro 02 – 08")
      dayRangeHeaderFormat: ({ start, end }, culture, loc) => {
        const m = loc.format(start, "MMMM", culture);
        const mCap = m.charAt(0).toUpperCase() + m.slice(1);
        const dStart = loc.format(start, "DD", culture);
        const dEnd = loc.format(end, "DD", culture);
        return `${mCap} ${dStart} – ${dEnd}`;
      },
    }),
    []
  );

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/;
    return regex.test(email.trim());
  };

  const formatCPF = (value) => {
    if (!value) return "";

    value = value.replace(/\D/g, "");

    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return value;
  };

  const validateCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, "");

    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
      return false;
    }

    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(9))) {
      return false;
    }

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(10))) {
      return false;
    }

    return true;
  };

  const formatCNPJ = (value) => {
    if (!value) return "";
    value = value.replace(/\D/g, "").slice(0, 14);
    value = value.replace(/^(\d{2})(\d)/, "$1.$2");
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
    value = value.replace(/(\d{4})(\d)/, "$1-$2");
    return value;
  };

  const validateCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/\D/g, "");
    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

    let length = cnpj.length - 2;
    let numbers = cnpj.substring(0, length);
    const digits = cnpj.substring(length);
    let sum = 0;
    let pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += numbers.charAt(length - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0))) return false;

    length = length + 1;
    numbers = cnpj.substring(0, length);
    sum = 0;
    pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += numbers.charAt(length - i) * pos--;
      if (pos < 2) pos = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(1))) return false;

    return true;
  };

  const formatCPFOrCNPJ = (value) => {
    const cleaned = value.replace(/\D/g, "");
    return cleaned.length <= 11 ? formatCPF(value) : formatCNPJ(value);
  };

  const validateCPForCNPJ = (doc) => {
    doc = doc.replace(/\D/g, "");

    if (doc.length === 11) return validateCPF(doc);
    if (doc.length === 14) return validateCNPJ(doc);

    return false;
  };

  const formatCEP = (value) => {
    const onlyNumbers = value.replace(/\D/g, "");

    if (onlyNumbers.length <= 5) {
      return onlyNumbers;
    }
    return `${onlyNumbers.slice(0, 5)}-${onlyNumbers.slice(5, 8)}`;
  };

  const validateCEP = (cep) => {
    const cleanedCEP = cep.replace(/\D/g, "");

    if (cleanedCEP.length !== 8) {
      return false;
    }

    if (/^(\d)\1+$/.test(cleanedCEP)) {
      return false;
    }

    return true;
  };

  const validatePhone = (phone) => {
    const onlyNumbers = phone.replace(/\D/g, "");

    return onlyNumbers.length === 10 || onlyNumbers.length === 11;
  };

  const clearFields = () => {
    handleLimparSelect();

    setTitleDrawer("");
    setDescriptionDrawer("");

    if (!onlyOption.agronomist) {
      setResponsavelTecnicoSelecionado(null);
    }

    if (!onlyOption.producer) {
      setProdutorSelecionado(null);
    }

    setFazendaSelecionada(null);
    setCulturaSelecionada(null);
    setStartDateDrawer("");
    setEndDateDrawer("");
    setStatusDrawer({ value: 0, label: "" });
    setAgroFarmsDrawer({ value: 0, label: "" });
    setAgroFarms([]);
    setIsFarmDisabled(true);
    setIsButtonFarmDisabled(true);

    setTitleError(false);
    setDescriptionError(false);
    setAgronomistError(false);
    setProducerError(false);
    setFarmError(false);
    setCultureError(false);
    setStartDateError(false);
    setEndDateError(false);
    setStatusError(false);
  };

  const validateForm = () => {
    let isValid = true;

    setTitleError(false);
    setDescriptionError(false);
    setAgronomistError(false);
    setProducerError(false);
    setFarmError(false);
    setCultureError(false);
    setStartDateError(false);
    setEndDateError(false);
    setStatusError(false);

    if (!titleDrawer.trim()) {
      setTitleError(true);
      isValid = false;
    }

    if (!responsavelTecnicoSelecionado || !responsavelTecnicoSelecionado.value) {
      setAgronomistError(true);
      isValid = false;
    }

    if (!startDateDrawer) {
      setStartDateError(true);
      isValid = false;
    }

    if (!endDateDrawer) {
      setEndDateError(true);
      isValid = false;
    }

    if (!statusDrawer.value) {
      setStatusError(true);
      isValid = false;
    }

    if (endDateDrawer < startDateDrawer) {
      setStartDateError(true);
      setEndDateError(true);

      store.addNotification({
        title: "Erro!",
        message: "A data final deve ser maior que a data inicial!",
        type: "warning",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });

      isValid = false;
    }

    return isValid;
  };

  const clearFieldsProducer = () => {
    setNameProducer("");
    setEmailProducer("");
    setCpfCnpjProducer("");
    setTelephoneProducer("");
    setCellphoneProducer("");
    setCepProducer("");
    setLogradouroProducer("");
    setBairroProducer("");
    setNumberProducer("");
    setComplementProducer("");
    setCityProducer("");
    setStateProducer({ value: 0, label: "" });

    setHasErrorProducer({
      nameProducer: false,
      emailProducer: false,
      cpfCnpjProducer: false,
      telephoneProducer: false,
      cellphoneProducer: false,
      cepProducer: false,
      logradouroProducer: false,
      bairroProducer: false,
      numberProducer: false,
      complementProducer: false,
      cityProducer: false,
      stateProducer: false,
    });
  };

  const clearFieldsFarm = () => {
    setNameFarm("");
    setCpfCnpjFarm("");
    setRegistrationStateFarm("");
    setCepFarm("");
    setLogradouroFarm("");
    setBairroFarm("");
    setNumberFarm("");
    setComplementFarm("");
    setCodeIbgeFarm("");
    setCityFarm("");
        setStateFarm({ value: 0, label: "" });
        setEstadoLocal("");

    setProducersRegistrationNumberAgencyFarm("");

    setTotalAreaFarm("");
    setCulturesFarm("");

    setOptionsCoordinatesFarm({ value: 0, label: "" });

    setHasErrorFarm({
      nameFarm: false,
      cpfCnpjFarm: false,
      registrationStateFarm: false,
      cepFarm: false,
      logradouroFarm: false,
      bairroFarm: false,
      numberFarm: false,
      complementFarm: false,
      codeIbgeFarm: false,
      cityFarm: false,
      stateFarm: false,
      geographicCoordinate: false,
    });
  };

  const validateFormAgronomist = async () => {
    let isValid = true;
    const newErrors = {
      name: false,
      email: false,
      cpf: false,
      whatsapp: false,
    };

    if (!nameAgronomist.trim()) {
      newErrors.name = true;
      isValid = false;
    }

    if (!emailAgronomist.trim() || !validateEmail(emailAgronomist)) {
      newErrors.email = true;
      isValid = false;
    }

    if (!cpfAgronomist.trim()) {
      newErrors.cpf = true;
      setCpfAgronomistErrorMsg('Campo obrigatório');
      isValid = false;
    } else {
      const resultadoCpf = await validadorCpfCnpj(cpfAgronomist);
      if (!resultadoCpf.valido) {
        newErrors.cpf = true;
        setCpfAgronomistErrorMsg(resultadoCpf.erro || 'Informe um CPF válido.');
        isValid = false;
      } else {
        setCpfAgronomistErrorMsg('');
      }
    }

    if (whatsappAgronomist.trim()) {
      if (!validatePhone(whatsappAgronomist)) {
        newErrors.whatsapp = true;
        isValid = false;
      }
    }

    setHasErrorAgronomist(newErrors);
    return isValid;
  };

  const validateFormProducer = async () => {
    let isValid = true;

    const newErrors = {
      nameProducer: false,
      emailProducer: false,
      cpfCnpjProducer: false,
      telephoneProducer: false,
      cellphoneProducer: false,
      cepProducer: false,
      logradouroProducer: false,
      bairroProducer: false,
      numberProducer: false,
      complementProducer: false,
      cityProducer: false,
      stateProducer: false,
    };

    if (!nameProducer.trim()) {
      newErrors.nameProducer = true;
      isValid = false;
    }

    if (!emailProducer.trim() || !validateEmail(emailProducer)) {
      newErrors.emailProducer = true;
      isValid = false;
    }

    if (!cpfCnpjProducer.trim()) {
      newErrors.cpfCnpjProducer = true;
      setCpfCnpjProducerErrorMsg('Campo obrigatório');
      isValid = false;
    } else {
      const resultadoDoc = await validadorCpfCnpj(cpfCnpjProducer);
      if (!resultadoDoc.valido) {
        newErrors.cpfCnpjProducer = true;
        setCpfCnpjProducerErrorMsg(resultadoDoc.erro || 'Informe um CPF/CNPJ válido.');
        isValid = false;
      } else {
        setCpfCnpjProducerErrorMsg('');
      }
    }

    if (!telephoneProducer.trim() || !validatePhone(telephoneProducer)) {
      newErrors.telephoneProducer = true;
      isValid = false;
    }

    if (!cepProducer.trim() || !validateCEP(cepProducer)) {
      newErrors.cepProducer = true;
      isValid = false;
    }

    if (!logradouroProducer.trim()) {
      newErrors.logradouroProducer = true;
      isValid = false;
    }

    if (!bairroProducer.trim()) {
      newErrors.bairroProducer = true;
      isValid = false;
    }

    if (!numberProducer.trim()) {
      newErrors.numberProducer = true;
      isValid = false;
    }

    if (!cityProducer.trim()) {
      newErrors.cityProducer = true;
      isValid = false;
    }

    if (!stateProducer.value) {
      newErrors.stateProducer = true;
      isValid = false;
    }

    setHasErrorProducer(newErrors);
    return isValid;
  };

  const validateFormFarm = async () => {
    let isValid = true;

    const newErrors = {
      nameFarm: false,
      cpfCnpjFarm: false,
      registrationStateFarm: false,
      cepFarm: false,
      logradouroFarm: false,
      bairroFarm: false,
      numberFarm: false,
      complementFarm: false,
      codeIbgeFarm: false,
      cityFarm: false,
      stateFarm: false,
      geographicCoordinate: false,
    };

    if (!nameFarm.trim()) {
      newErrors.nameFarm = true;
      isValid = false;
    }

    if (!cpfCnpjFarm.trim()) {
      newErrors.cpfCnpjFarm = true;
      setCpfCnpjFarmErrorMsg('Campo obrigatório');
      isValid = false;
    } else {
      const resultadoDoc = await validadorCpfCnpj(cpfCnpjFarm);
      if (!resultadoDoc.valido) {
        newErrors.cpfCnpjFarm = true;
        setCpfCnpjFarmErrorMsg(resultadoDoc.erro || 'Informe um CPF/CNPJ válido.');
        isValid = false;
      } else {
        setCpfCnpjFarmErrorMsg('');
      }
    }

    if (!cepFarm.trim() || !validateCEP(cepFarm)) {
      newErrors.cepFarm = true;
      isValid = false;
    }

    if (!logradouroFarm.trim()) {
      newErrors.logradouroFarm = true;
      isValid = false;
    }

    if (!bairroFarm.trim()) {
      newErrors.bairroFarm = true;
      isValid = false;
    }

    if (!numberFarm.trim()) {
      newErrors.numberFarm = true;
      isValid = false;
    }

    if (!codeIbgeFarm.trim()) {
      newErrors.codeIbgeFarm = true;
      isValid = false;
    }

    if (!cityFarm.trim()) {
      newErrors.cityFarm = true;
      isValid = false;
    }

    if (!stateFarm.value) {
      newErrors.stateFarm = true;
      isValid = false;
    }

    if (isEstadoObrigatorio(stateFarm.value) && !optionsCoordinatesFarm.value) {
      newErrors.geographicCoordinate = true;
      isValid = false;
    }

    setHasErrorFarm(newErrors);
    return isValid;
  };

  const handleBlurCpfAgronomist = async () => {
    if (!cpfAgronomist.trim()) return;

    const resultado = await validadorCpfCnpj(cpfAgronomist);
    if (!resultado.valido) {
      setHasErrorAgronomist(prev => ({ ...prev, cpf: true }));
      setCpfAgronomistErrorMsg(resultado.erro || 'Informe um CPF válido.');
    } else {
      setHasErrorAgronomist(prev => ({ ...prev, cpf: false }));
      setCpfAgronomistErrorMsg('');
    }
  };

  const handleBlurCpfCnpjProducer = async () => {
    if (!cpfCnpjProducer.trim()) return;

    const resultado = await validadorCpfCnpj(cpfCnpjProducer);
    if (!resultado.valido) {
      setHasErrorProducer(prev => ({ ...prev, cpfCnpjProducer: true }));
      setCpfCnpjProducerErrorMsg(resultado.erro || 'Informe um CPF/CNPJ válido.');
    } else {
      setHasErrorProducer(prev => ({ ...prev, cpfCnpjProducer: false }));
      setCpfCnpjProducerErrorMsg('');
    }
  };

  const handleBlurCpfCnpjFarm = async () => {
    if (!cpfCnpjFarm.trim()) return;

    const resultado = await validadorCpfCnpj(cpfCnpjFarm);
    if (!resultado.valido) {
      setHasErrorFarm(prev => ({ ...prev, cpfCnpjFarm: true }));
      setCpfCnpjFarmErrorMsg(resultado.erro || 'Informe um CPF/CNPJ válido.');
    } else {
      setHasErrorFarm(prev => ({ ...prev, cpfCnpjFarm: false }));
      setCpfCnpjFarmErrorMsg('');
    }
  };

  const handleSaveEvent = async () => {
    if (!validateForm()) {
      store.addNotification({
        title: "Erro!",
        message: "Preencha todos os campos obrigatórios",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    setIsLoading(true);

    let coords = userCoords;
    let capturedNow = false;
    if (!coords) {
      coords = await tryGetGeolocation();
      if (coords) { setUserCoords(coords); capturedNow = true; }
    }
    if (capturedNow && coords && coords.latitude != null && coords.longitude != null) {
      store.addNotification({
        title: "Localização registrada",
        message: `Coordenadas capturadas: ${typeof coords.latitude === 'number' ? coords.latitude.toFixed(6) : coords.latitude}, ${typeof coords.longitude === 'number' ? coords.longitude.toFixed(6) : coords.longitude}`,
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    }

    const payload = {
      title: titleDrawer,
      agro_agronomist_id: parseInt(responsavelTecnicoSelecionado.value),
      agro_producer_id: produtorSelecionado?.value ? parseInt(produtorSelecionado.value) : null,
      agro_farm_id: fazendaSelecionada?.value ? parseInt(fazendaSelecionada.value) : null,
      description: descriptionDrawer,
      agro_culture_id: culturaSelecionada?.value ? parseInt(culturaSelecionada.value) : null,
      date_begin: formatarDataParaAPI(startDateDrawer),
      date_end: formatarDataParaAPI(endDateDrawer),
      agro_task_status_id: parseInt(statusDrawer.value),
      ...(coords && coords.latitude != null && coords.longitude != null ? { latitude: String(coords.latitude), longitude: String(coords.longitude) } : {}),
    };

    try {
      const response = await api.post("/agenda", payload);

      if (response) {
        setShowNewEvent(false);
        setIsEdit(false);
        clearFields();

        consultEventInit();

        store.addNotification({
          title: "Sucesso!",
          message: `${response.data.message}`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true },
        });
        if (coords && coords.latitude != null && coords.longitude != null) {
          store.addNotification({
            title: "Localização registrada",
            message: `Coordenadas salvas no evento: ${String(coords.latitude)}, ${String(coords.longitude)}`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 4000, onScreen: true },
          });
        } else {
          store.addNotification({
            title: "Aviso",
            message: "Evento criado sem geolocalização.",
            type: "info",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 4000, onScreen: true },
          });
        }
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Erro ao salvar evento";

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, errorMessage),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getAgronomists = async () => {
    const payload = {
      search: "",
      estado: "",
    };

    try {
      const response = await api.post(
        "/agronomos/pesquisa?limit=30&offset=0",
        payload
      );

      const agronomistsData = response.data.data.agronomists.map(
        (agronomist) => ({
          value: agronomist.id,
          label: agronomist.nome,
        })
      );

      setAgronomists(agronomistsData);

      if (agronomistsData.length === 1) {
        setOnlyOption((prev) => ({ ...prev, agronomist: true }));

        setAgronomistDrawer({
          value: agronomistsData[0].value,
          label: agronomistsData[0].label,
        });
        setAgronomistError(false);
      }
    } catch (error) {}
  };

  const getAllProducers = async () => {
    const payload = {
      search: "",
      estado: "",
      order_by: { field: "modified", order: "DESC" },
    };

    try {
      const response = await api.post(
        "/produtores/pesquisa?limit=30&offset=0",
        payload
      );

      const produtores = response.data.data.produtores;

      const producersData = produtores.map((producer) => ({
        value: producer.id,
        label: producer.nome + " - " + formatCPFOrCNPJ(producer.cpf_cnpj),
        agro_farms: producer.agro_farms.map((farm) => ({
          id: farm.id,
          label: farm.nome,
          state: farm.estado,
        })),
      }));

      setProducers(producersData);

      if (producersData.length === 1) {
        const unico = producersData[0];
        setProducerDrawer({ value: unico.value, label: unico.label });
        setProducerError(false);
        // getAgroFarms(unico.value);
      }
    } catch (error) {
      console.error("Erro ao buscar produtores:", error);
    }
  };
  //   const state = {
  //     estado: "SP",
  //   };

  //   try {
  //     const response = await api.get(`/produtores/estado/${state.estado}`);

  //     const producersData = response.data.data.map((producer) => ({
  //       value: producer.id,
  //       label: producer.nome,
  //       agro_farms: producer.agro_farms.map((farm) => ({
  //         id: farm.id,
  //         label: farm.nome,
  //         state: farm.estado,
  //       })),
  //     }));

  //     setProducers(producersData);

  //     if (producersData.length === 1) {
  //       setOnlyOption(prev => ({ ...prev, producer: true }));

  //       setProducerDrawer({
  //         value: producersData[0].value,
  //         label: producersData[0].label,
  //       });
  //       setProducerError(false);

  //       getAgroFarms(producersData[0].value);
  //     }
  //   } catch (error) {
  //   }
  // };

  const getAgroFarms = async (producerId) => {
    if (!producerId) return;

    try {
      const response = await api.get(`/produtores/${producerId}/fazendas`);
      const agroFarmsData = response.data.data.map((agroFarm) => ({
        value: agroFarm.id,
        label: agroFarm.nome,
      }));

      setFazendaSelecionada(null)
      setAgroFarms(agroFarmsData);
      setIsFarmDisabled(false);
      setIsButtonFarmDisabled(false);

      if (agroFarmsData.length === 1) {
        setOnlyOption((prev) => ({ ...prev, farm: true }));

        const selectedFarm = {
          value: agroFarmsData[0].value,
          label: agroFarmsData[0].label,
        };

        setAgroFarmsDrawer(selectedFarm);
        setFarmError(false);

        setTimeout(() => {
          if (selectAgroFarmsRef.current) {
            const selectElement = selectAgroFarmsRef.current;

            if (typeof selectElement.handleChange === "function") {
              selectElement.handleChange({
                target: { value: String(selectedFarm.value) },
              });
            }
          }
        }, 100);
      }
    } catch (error) {
      setFazendaSelecionada(null)
      setIsFarmDisabled(true);
      setIsButtonFarmDisabled(false);

      setFarmError(true);

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, "ERRO-678 Nenhuma fazenda foi encontrada para esse produtor - Tente novamente, se o erro persistir acione o suporte."),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    }
  };

  const getCultures = async () => {
    try {
      const response = await api.get("/culturas");

      const allCultures = response.data.data.flat();

      const culturesData = allCultures.map((culture) => ({
        value: culture.id,
        label: culture.nome_comum,
      }));

      setCultures(culturesData);

      if (culturesData.length === 1) {
        setCultureDrawer({
          value: culturesData[0].value,
          label: culturesData[0].label,
        });
        setCultureError(false);
      }
    } catch (error) {}
  };

  const copyTextToClipboard = async (text) => {
    if (!text) return false;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (error) {}

    try {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.top = "-9999px";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(textarea);
      return ok;
    } catch (error) {
      return false;
    }
  };

  const notifyPhoneCopied = () => {
    store.addNotification({
      title: "Sucesso!",
      message: "O telefone foi copiado com sucesso.",
      type: "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 4000, onScreen: true },
    });
  };

  const formatPhoneNumber = (phone) => {
    if (!phone) return "";

    return String(phone).replace(/\D/g, "");
  };

  const getStatusLabel = (statusId) => {
    const statusMap = {
      1: "Não iniciado",
      2: "Em progresso",
      3: "Aguardando aprovação",
      4: "Pausado",
      5: "Atrasado",
      6: "Cancelado",
      7: "Feito",
    };
    return statusMap[statusId] || "";
  };

  const buildMeteoblueUrl = (lat, lng) => {
    if (lat == null || lng == null) return null;
    return `https://www.meteoblue.com/en/weather/maps/widget/${lat}N${lng}E654_America%2FSao_Paulo?windAnimation=1&gust=1&satellite=1&cloudsAndPrecipitation=1&temperature=1&sunshine=1&extremeForecastIndex=1&geoloc=fixed&tempunit=C&windunit=km%252Fh&lengthunit=metric&zoom=10&autowidth=auto`;
  };

  const [agroFarmIdToSelect, setAgroFarmIdToSelect] = useState(null);
  const [userCoords, setUserCoords] = useState(null);
  const [eventCoords, setEventCoords] = useState(null);

  useEffect(() => {
    if (agroFarms.length > 0 && agroFarmIdToSelect) {
      const farm = agroFarms.find((f) => f.value === agroFarmIdToSelect);
      setFazendaSelecionada({
        value: agroFarmIdToSelect,
        label: farm?.label || "",
      });
    }
  }, [agroFarms, agroFarmIdToSelect]);

  useEffect(() => {
    if (showNewEvent && !eventCoords && !userCoords) {
      tryGetGeolocation()
        .then((c) => setUserCoords(c))
        .catch(() => {});
    }
  }, [showNewEvent, eventCoords, userCoords]);

  const getEventId = async (item) => {
    setRenderFarm(true)
    setResponsavelTecnicoSelecionado(null);
    setProdutorSelecionado(null);
    setFazendaSelecionada(null);
    try {
      const response = await api.get(`/agenda/${item.id}`);

      setIsEdit(true);
      setShowNewEvent(true);

      const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().slice(0, 16);
      };

      setTitleDrawer(response.data.title);
      setDescriptionDrawer(response.data.description);
      setStartDateDrawer(formatDateForInput(response.data.date_begin));
      setEndDateDrawer(formatDateForInput(response.data.date_end));

      if (response.data.agro_agronomist_id) {
        try {
          const responseAgronomist = await api.get(
            `/agronomos/${response.data.agro_agronomist_id}`
          );
          const agronomist = responseAgronomist.data.data;

          const data = {
            value: agronomist.id,
            label: agronomist.nome,
          };

          setResponsavelTecnicoSelecionado(data);
        } catch (error) {}
      }

      const producer = producers.find(
        (p) => p.value === response.data.agro_producer_id
      );
      setProdutorSelecionado({
        value: response.data.agro_producer_id,
        label: producer?.label || "",
      });

      await getAgroFarms(response.data.agro_producer_id);
      setAgroFarmIdToSelect(response.data.agro_farm_id);

      const culture = cultures.find(
        (c) => c.value === response.data.agro_culture_id
      );
      setCulturaSelecionada({
        value: response.data.agro_culture_id,
        label: culture?.label || "",
      });

      setStatusDrawer({
        value: response.data.agro_task_status_id,
        label: getStatusLabel(response.data.agro_task_status_id),
      });

      try {
        const latCandidate =
          response.data?.latitude ??
          response.data?.lat ??
          response.data?.event_latitude ??
          response.data?.local_latitude ??
          response.data?.agro_farms?.latitude;
        const lngCandidate =
          response.data?.longitude ??
          response.data?.lng ??
          response.data?.event_longitude ??
          response.data?.local_longitude ??
          response.data?.agro_farms?.longitude;

        if (latCandidate != null && latCandidate !== '' && lngCandidate != null && lngCandidate !== '') {
          const lat = typeof latCandidate === 'string' ? (parseFloat(latCandidate) ?? latCandidate) : latCandidate;
          const lng = typeof lngCandidate === 'string' ? (parseFloat(lngCandidate) ?? lngCandidate) : lngCandidate;
          const coords = { latitude: lat, longitude: lng };
          setEventCoords(coords);
          if (!userCoords) setUserCoords(coords);
        } else {
          setEventCoords(null);
        }
      } catch (_) {
        setEventCoords(null);
      }
    } catch (error) {

    } finally {
      setRenderFarm(false)
    }
  };

  const handleEditEvent = async (item) => {
    if (!validateForm()) {
      store.addNotification({
        title: "Atenção!",
        message: "Preencha todos os campos",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    setIsLoading(true);

    const payload = {
      title: titleDrawer,
      agro_agronomist_id: parseInt(responsavelTecnicoSelecionado.value),
      agro_producer_id: produtorSelecionado?.value ? parseInt(produtorSelecionado.value) : null,
      agro_farm_id: fazendaSelecionada?.value ? parseInt(fazendaSelecionada.value) : null,
      description: descriptionDrawer,
      agro_culture_id: culturaSelecionada?.value ? parseInt(culturaSelecionada.value) : null,
      date_begin: formatarDataParaAPI(startDateDrawer),
      date_end: formatarDataParaAPI(endDateDrawer),
      agro_task_status_id: parseInt(statusDrawer.value),
    };

    try {
      const response = await api.put(`/agenda/${currentId}`, payload);

      if (response) {
        setShowNewEvent(false);
        setIsEdit(false);
        clearFields();

        consultEventInit();

        store.addNotification({
          title: "Sucesso!",
          message: `${response.data.message}`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true },
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Erro ao salvar evento";

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, errorMessage),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleLimparSelect = () => {
    if (selectAgronomistRef.current && onlyOption.agronomist === false) {
      selectAgronomistRef.current.clearSelect();
    }

    if (selectProducerRef.current) {
      selectProducerRef.current.clearSelect();
    }

    if (selectAgroFarmsRef.current) {
      selectAgroFarmsRef.current.clearSelect();
    }

    if (selectCultureRef.current) {
      selectCultureRef.current.clearSelect();
    }

    if (selectStatusRef.current) {
      selectStatusRef.current.clearSelect();
    }
  };

  const consultEventInit = async () => {
    setIsLoadingResume(true);

    const payload = {
      search: "",
      agronomists: [],
      producers: [],
      farms: [],
      cultures: [],
      status: [],
      date_end: "",
      date_begin: "",
    };

    try {
      const response = await api.post(`/agenda/consulta`, payload);

      setConsult(response.data);
    } catch (error) {
    } finally {
      setIsLoadingResume(false);
    }
  };

  useEffect(() => {
    getAgronomists();
    getCultures();
    getAllProducers();
    consultEventInit();
    getEstadosCood();

    const loadSignTypes = async () => {
      try {
        const response = await api.get('/agronomos/crea/assinaturas');
        const data = response?.data?.data;
        if (data) {
          setEstadosDigital(data.digital || []);
          setExcecoesEletronica(data.excecao_eletronica || []);
        }
      } catch (error) {}
    };
    loadSignTypes();
  }, []);

  const getEstadosCood = async () => {
    try {
      const response = await api.get(`/fazendas/estados`);

      let estados = [];

      if (response && response.data) {
        if (Array.isArray(response.data.estados)) {
          estados = response.data.estados;
        } else if (response.data.data && Array.isArray(response.data.data.estados)) {
          estados = response.data.data.estados;
        }
      }

      setEstadosObrigatorios(estados);
    } catch (error) {
        store.addNotification({
          title: "Erro!",
          message: identifyErrorMenssage(error, "ERRO-679 Erro ao buscar estados com coordenadas obrigatórias - Tente novamente, se o erro persistir acione o suporte."),
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
              duration: 4000,
              onScreen: true
          }
      });
    }
  };

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const idParam = params.get('id');

      if (!openedByParamRef.current && idParam) {
        const scheduleId = parseInt(idParam, 10);
        if (!isNaN(scheduleId) && scheduleId > 0) {
          const original = consult?.data?.find((i) => i.id === scheduleId);
          if (original) {
            getEventId(original);
            setCurrentId(original.id);
          } else {
            getEventId({ id: scheduleId });
            setCurrentId(scheduleId);
          }
          openedByParamRef.current = true;
        }
      }
    } catch (_) {}
  }, [consult]);

  const tipoAssinatura = (e) => {
    if (e === "E") {
      setEletronica(true);
      setDigital(false);
      setManual(false);
    } else if (e === "D") {
      setEletronica(false);
      setDigital(true);
      setManual(false);
    } else {
      setEletronica(false);
      setDigital(false);
      setManual(true);
    }
  };

  const deleteFile = () => {
    setNamesfiles([]);
    setIsValidate(false);
  };

  const editSign = (e) => {
    setAssinatura(e);
  };

  const onChangeCertificate = (e) => {
    let user = JSON.parse(localStorage.getItem(USER));

    if (user.contract_software_id === 6) {
      setShowModalBlock(true);
    } else {
      let cont = e.target.files.length;
      cont = cont - 1;

      if (e.target.files) {
        if (e.target.files[cont].type === "application/x-pkcs12") {
          let fil = e.target.files;
          let reader = new FileReader();
          reader.readAsDataURL(fil[0]);

          reader.onload = (e) => {
            setFile(e.target.result);
            setTextFile(e.target.result);

            if (cpf) {
              setShowModal(true);
            } else {
              const input = document.getElementById("cpf");
              input.classList.add("error");
              store.addNotification({
                title: "Erro!",
                message: `Informe o CPF!`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 4000,
                  onScreen: true,
                },
              });
            }
          };
          setNamesfiles(e.target.files[cont].name);
        } else {
          store.addNotification({
            title: "Erro!",
            message: `O arquivo selecionado não possui a extensão correta`,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 4000,
              onScreen: true,
            },
          });
        }
      } else {
        store.addNotification({
          title: "Erro!",
          message: `Não é possível enviar mais que um arquivo!`,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });
      }
    }
  };

  const options = {
    "Responsável Técnico": consult.filters?.responsaveis?.map(
      (responsaveis) => ({
        id: parseInt(responsaveis.value),
        label: responsaveis.label,
      })
    ),
    Produtor: consult.filters?.produtores.map((produtores) => ({
      id: parseInt(produtores.value),
      label: produtores.label,
    })),
    "Fazenda/Sítio": consult.filters?.fazendas.map((fazendas) => ({
      id: parseInt(fazendas.value),
      label: fazendas.label,
    })),
    Cultura: consult.filters?.culturas.map((culturas) => ({
      id: parseInt(culturas.value),
      label: culturas.label,
    })),
  };

  const showDeleteConfirmation = () => {
    setShowDeleteConfirmModal(true)
  }

  const handleDeleteConfirmation = (response) => {
    setShowDeleteConfirmModal(false)
    if (response === 1) {
      deleteEvent()
    }
  }

  const deleteEvent = async () => {
    try {
      const response = await api.delete(`/agenda/${currentId}`);

      if (response) {
        setShowNewEvent(false);
        setIsEdit(false);

        store.addNotification({
          title: "Sucesso!",
          message: `${response.data.message}`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });

        consultEventInit();
        clearFields();
      }
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    }
  };

  const validarDatasEConsultar = () => {
    if (!startDateFilter && !endDateFilter) {
      consultEvent();
      return;
    }

    if (
      (!startDateFilter && endDateFilter) ||
      (startDateFilter && !endDateFilter)
    ) {
      return;
    }

    // Verifica se a data de início é anterior à data de término
    const startDate = new Date(startDateFilter);
    const endDate = new Date(endDateFilter);

    if (startDate > endDate) {
      // Mostrar uma notificação de erro
      store.addNotification({
        title: "Erro",
        message: "A data de início deve ser anterior à data de término",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });
      return;
    }

    // Se todas as validações passarem, chama consultEvent
    consultEvent();
  };

  const handleSearchEvent = (value) => {
    setSearch(value);

    consultEvent({}, {}, false, value);
  };

  const consultEvent = async (
    selectedOptions = {},
    options = {},
    isDispensed = false,
    searchValue = search
  ) => {
    const selectedIds = {
      agronomists: selectedOptions["Responsável Técnico"] || [],
      producers: selectedOptions["Produtor"] || [],
      farms: selectedOptions["Fazenda/Sítio"] || [],
      cultures: selectedOptions["Cultura"] || [],
      date_begin: selectedOptions["Data do evento"]?.[0] || null,
    };

    setIsLoadingResume(true);

    const payload = {
      search: searchValue,
      agronomists: selectedIds.agronomists,
      producers: selectedIds.producers,
      farms: selectedIds.farms,
      cultures: selectedIds.cultures,
      date_begin: startDateFilter || "",
      date_end: endDateFilter || "",
    };

    try {
      const response = await api.post(`/agenda/consulta`, payload);

      const filteredResponse = isDispensed
        ? {
            ...response.data,
            data: response.data.data.filter(
              (ev) => ev.agro_task_status?.id !== 6
            ),
          }
        : response.data;

      setConsult(filteredResponse);
    } catch (error) {
    } finally {
      setIsLoadingResume(false);
    }
  };

  const handleCreateAgronomist = async () => {
    if (!(await validateFormAgronomist())) {
      store.addNotification({
        title: "Erro!",
        message: "Preencha todos os campos obrigatórios",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    setIsLoadingSavedAgronomist(true);

    const payload = {
      nome: nameAgronomist,
      email: emailAgronomist,
      cpf: cpfAgronomist,
      whatsapp: whatsappAgronomist,
      enviar_receita: 0,
      assinatura: "",
    };
    try {
      const response = await api.post("/agronomos", payload);

      if (response) {
        store.addNotification({
          title: "Sucesso!",
          message: `Responsável técnico adicionado com sucesso`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });

        setShowAddAgronomist(false)
        getAgronomists();
      }
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 5500,
          onScreen: true,
        },
      });
    } finally {
      setIsLoadingSavedAgronomist(false);
    }
  };

  const handleCreateProducer = async () => {
    if (!(await validateFormProducer())) {
      store.addNotification({
        title: "Erro!",
        message: "Preencha todos os campos obrigatórios",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    setIsLoadingSavedProducer(true);

    const payload = {
      nome: nameProducer,
      email: emailProducer,
      cpf_cnpj: cpfCnpjProducer,
      telefone: telephoneProducer,
      celular: cellphoneProducer,
      cep: cepProducer,
      logradouro: logradouroProducer,
      bairro: bairroProducer,
      numero: numberProducer,
      complemento: complementProducer,
      cidade: cityProducer,
      estado: stateProducer.value,
    };

    try {
      const response = await api.post("/produtores", payload);

      if (response.status === 200) {
        setShowAddProducer(false);

        setNameProducer("");
        setEmailProducer("");
        setCpfCnpjProducer("");
        setTelephoneProducer("");
        setCellphoneProducer("");
        setCepProducer("");
        setLogradouroProducer("");
        setBairroProducer("");
        setNumberProducer("");
        setComplementProducer("");
        setCityProducer("");
        setStateProducer("");

        store.addNotification({
          title: "Sucesso!",
          message: `Produtor adicionado com sucesso`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });

        getAllProducers();
      }
    } catch (error) {
    } finally {
      setIsLoadingSavedProducer(false);
    }
  };

  const handleCreateFarm = async () => {
    if (!(await validateFormFarm())) {
      store.addNotification({
        title: "Erro!",
        message: "Preencha todos os campos obrigatórios",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    setIsLoadingSavedFarm(true);

    const payload = {
      nome: nameFarm,
      cpf_cnpj: cpfCnpjFarm,
      cod_ibge: codeIbgeFarm,
      cultura: [1],
      area_total: totalAreaFarm,
      inscricao_estadual: registrationStateFarm,
      cadastro_ambiental: registrationAmbientFarm,
      inscricao_orgao: producersRegistrationNumberAgencyFarm,
      cep: cepFarm,
      endereco: logradouroFarm,
      numero: numberFarm,
      complemento: complementFarm,
      bairro: bairroFarm,
      estado: stateFarm.value,
      cidade: cityFarm,
      latitude: latitudeFarm,
      longitude: longitudeFarm,
      altitude: altitudeFarm,
    };

    try {
      const response = await api.post(
        `/produtores/${idProducer}/fazendas`,
        payload
      );

      if (response.status === 200) {
        setShowAddFarm(false);

        setNameFarm("");
        setCpfCnpjFarm("");
        setCodeIbgeFarm("");
        setTotalAreaFarm("");
        setRegistrationStateFarm("");
        setRegistrationAmbientFarm("");
        setProducersRegistrationNumberAgencyFarm("");
        setCepFarm("");
        setLogradouroFarm("");
        setNumberFarm("");
        setComplementFarm("");
        setBairroFarm("");
        setStateFarm("");
        setEstadoLocal("");
        setCityFarm("");
        setLatitudeFarm("");
        setLongitudeFarm("");
        setAltitudeFarm("");

        store.addNotification({
          title: "Sucesso!",
          message: `Fazenda adicionada com sucesso`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });

        getAgroFarms(idProducer);
      }
    } catch (error) {
    } finally {
      setIsLoadingSavedFarm(false);
    }
  };

  const filterTelefoneInput = (value) => {
    if (value == null) return "";
    return String(value).replace(/[^0-9]/g, "");
  };
  
  const formatTelefone = (value) => {
    const numbers = filterTelefoneInput(value); 
    let formattedValue = numbers;

    if (numbers.length > 2) {
      formattedValue = `(${numbers.slice(0, 2)})${numbers.slice(2)}`;
    }
    if (numbers.length > 6 && numbers.length <= 10) {
      formattedValue = `${formattedValue.slice(0, 8)}-${formattedValue.slice(8, 12)}`;
    } else if (numbers.length > 10) {
      formattedValue = `${formattedValue.slice(0, 9)}-${formattedValue.slice(9, 13)}`;
    }

    return formattedValue;
  };

  const handleFilterOption = (option) => {
    // Agora apenas alterna o layout exibido (Mês/Semana/Dia/Agenda)
    setActiveFilter(option);
  };

  const consultEventWithParams = async (params) => {
    setIsLoadingResume(true);

    try {
      const response = await api.post(`/agenda/consulta`, params);

      setConsult(response.data);
    } catch (error) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });
    } finally {
      setIsLoadingResume(false);
    }
  };

  const fetchCep = async (cep, formType = "produtor") => {
    try {
      const cepData = await buscaCep(cep);
      const { logradouro, bairro, localidade, uf, estado } = cepData;

      switch (formType) {
        case "produtor":
          setLogradouroProducer(logradouro);
          setBairroProducer(bairro);
          setCityProducer(localidade);

          setStateProducer({ value: uf, label: estado });

          setHasErrorProducer((prev) => ({
            ...prev,
            logradouroProducer: false,
            bairroProducer: false,
            cityProducer: false,
            stateProducer: false,
          }));
          break;

        case "fazenda":
          setLogradouroFarm(logradouro);
          setBairroFarm(bairro);
          setCityFarm(localidade);
          setStateFarm({ value: uf, label: estado });
          setEstadoLocal(uf);

          setHasErrorProducer((prev) => ({
            ...prev,
            logradouroFarm: false,
            bairroFarm: false,
            cityFarm: false,
            geographicCoordinate: false,
          }));
          break;

        default:
          break;
      }
    } catch (err) {
      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(err),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 4000,
          onScreen: true,
        },
      });
    }
  };

  const [width, setWidth] = useState(window.innerWidth);
  const [showFilters, setShowFilters] = useState(false);

  // Exibe filtros apenas se a API retornar alguma opção para filtrar
  const shouldShowFilter = useMemo(() => {
    const f = consult && consult.filters;
    if (!f) return false;
    const keys = [
      "responsaveis",
      "produtores",
      "fazendas",
      "culturas",
      "status",
      "datas",
    ];
    return keys.some((k) => Array.isArray(f[k]) && f[k].length > 0);
  }, [consult]);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const hasReloaded = sessionStorage.getItem("hasReloaded");

    if (!hasReloaded) {
      sessionStorage.setItem("hasReloaded", "true");
      window.location.reload();
    } else {
      sessionStorage.removeItem("hasReloaded");
    }
  }, []);

  useEffect(() => {
    if (
      USERJSON.contrato.agro_plan_config.agro_plan_id === 7 ||
      USERJSON.contrato.agro_plan_config.agro_plan_id === 6 ||
      USERJSON.contrato.agro_plan_config.agro_plan_id === 4
    ) {
      setOpenModalTrue(true);
    }
  }, [USERJSON]);

  const [renderFarm, setRenderFarm] = useState(false);
  const [responsavelTecnicoSelecionado, setResponsavelTecnicoSelecionado] = useState(null);
  const [produtorSelecionado, setProdutorSelecionado] = useState(null);
  const [fazendaSelecionada, setFazendaSelecionada] = useState(null);
  const [culturaSelecionada, setCulturaSelecionada] = useState(null);

  return (
    <S.Container>
      <S.Wrapper>
        <HeaderV2 title="Caderno de campo" />

        <S.ContainerContent>
          <S.DiaryAndData>
            <S.Option
              onClick={() => handleFilterOption("agenda")}
              activeFilter={activeFilter}
              filterType="agenda"
            >
              <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                Agenda
              </TaglineM>
            </S.Option>

            <S.Option
              onClick={() => handleFilterOption("mes")}
              activeFilter={activeFilter}
              filterType="mes"
            >
              <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                Mês
              </TaglineM>
            </S.Option>

            <S.Option
              onClick={() => handleFilterOption("semana")}
              activeFilter={activeFilter}
              filterType="semana"
            >
              <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                Semana
              </TaglineM>
            </S.Option>

            <S.Option
              onClick={() => handleFilterOption("dia")}
              activeFilter={activeFilter}
              filterType="dia"
            >
              <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                Dia
              </TaglineM>
            </S.Option>
          </S.DiaryAndData>

          <S.Content>
            {width > 768 && shouldShowFilter && (
              <FilterV2
                filterOptions={options}
                onBlurFilter={consultEvent}
                startDateValue={startDateFilter}
                endDateValue={endDateFilter}
              >
                <S.ContainerFilterChindren>
                  <InputV3
                    id="datetime-start"
                    type="date"
                    label="Selecione Data de início"
                    floatingLabelWithAsterisk="Data de início"
                    value={startDateFilter}
                    min="2000-01-01"
                    max="2100-12-31"
                    onChange={(e) => {
                      setStartDateFilter(e.target.value);
                    }}
                    onBlur={() => {
                      validarDatasEConsultar();
                    }}
                    handleClear={() => {
                      setStartDateFilter("");
                      validarDatasEConsultar();
                    }}
                  />

                  <InputV3
                    id="datetime-end"
                    type="date"
                    label="Selecione Data de término"
                    floatingLabelWithAsterisk="Data de término"
                    value={endDateFilter}
                    min="2000-01-01"
                    max="2100-12-31"
                    onChange={(e) => {
                      setEndDateFilter(e.target.value);
                    }}
                    onBlur={() => {
                      validarDatasEConsultar();
                    }}
                    handleClear={() => {
                      setEndDateFilter("");
                      validarDatasEConsultar();
                    }}
                  />
                </S.ContainerFilterChindren>
              </FilterV2>
            )}

            <S.ContentOfSearch>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <InputV3
                  type="search"
                  floatingLabel="Título do evento ou Descrição"
                  radius={true}
                  searchLeft={true}
                  value={search}
                  onChange={(e) => handleSearchEvent(e.target.value)}
                />

                {width < 768 && shouldShowFilter && (
                  <img
                    style={{ width: "32px" }}
                    src={Filter}
                    onClick={() => setShowFilters(true)}
                  ></img>
                )}
              </div>

              <S.Button onClick={handleCreateEventClick}>
                <img src={plus} alt="Adicionar" />

                <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>
                  Criar evento
                </TaglineM>
              </S.Button>

              {activeFilter !== "agenda" ? (
                <div style={{ width: "100%" }}>
                  <Calendar
                    localizer={localizer}
                    events={calendarEvents}
                    selectable
                    onSelectSlot={(slotInfo) => {
                      // Apenas reage a cliques em dias vazios na visão Mês
                      if (activeFilter === "mes") {
                        // slotInfo.start é a data do dia clicado
                        // Pré-preenche datas do Drawer com 00:00 e fim 00:00 do dia seguinte
                        try {
                          const startLocal = new Date(slotInfo.start);
                          startLocal.setHours(0, 0, 0, 0);
                          const endLocal = new Date(startLocal);
                          endLocal.setDate(endLocal.getDate() + 1);

                          setStartDateDrawer(formatDateTimeLocalInput(startLocal));
                          setEndDateDrawer(formatDateTimeLocalInput(endLocal));
                        } catch (_) {}
                        setIsEdit(false);
                        openNewEventDrawer();
                      } else if (
                        activeFilter === "semana" ||
                        activeFilter === "dia"
                      ) {
                        // Na visão Semana/Dia, usa o horário do slot selecionado
                        try {
                          const startLocal = new Date(slotInfo.start);
                          const endCandidate = new Date(slotInfo.end);
                          const endLocal =
                            endCandidate > startLocal
                              ? endCandidate
                              : new Date(startLocal.getTime() + 60 * 60 * 1000);

                          setStartDateDrawer(
                            formatDateTimeLocalInput(startLocal)
                          );
                          setEndDateDrawer(formatDateTimeLocalInput(endLocal));
                        } catch (_) {}
                        setIsEdit(false);
                        openNewEventDrawer();
                      }
                    }}
                    views={[
                      activeFilter === "mes"
                        ? Views.MONTH
                        : activeFilter === "semana"
                        ? Views.WEEK
                        : Views.DAY,
                    ]}
                    view={
                      activeFilter === "mes"
                        ? Views.MONTH
                        : activeFilter === "semana"
                        ? Views.WEEK
                        : Views.DAY
                    }
                    formats={calendarFormats}
                    messages={{
                      week: "Semana",
                      work_week: "Semana de trabalho",
                      day: "Dia",
                      month: "Mês",
                      previous: "<",
                      next: ">",
                      today: "Hoje",
                      agenda: "Agenda",
                      noEventsInRange: "Nenhum evento programado.",
                      date: "Data",
                      time: "Hora",
                      event: "Evento",
                      allDay: "O dia todo",
                      showMore: (total) => `+${total} eventos`,
                    }}
                    onSelectEvent={(ev) => {
                      const original = consult.data?.find(
                        (i) => i.id === ev.id
                      );
                      if (original) {
                        getEventId(original);
                        setCurrentId(original.id);
                      }
                    }}
                    popup
                    style={{ fontFamily: "lato", height: 640 }}
                  />
                </div>
              ) : (
                <S.ContainerCards>
                  {isLoadingResume && (
                    <S.ContainerLoading>
                      <S.LoadingResume />
                    </S.ContainerLoading>
                  )}

                  {isLoadingResume === false &&
                    consult.data?.length > 0 &&
                    consult.data?.map((item) => (
                      <S.Card
                        key={item.id}
                        onClick={(e) => {
                          if (e?.target?.closest?.("a")) return;
                          getEventId(item);
                          setCurrentId(item.id);
                        }}
                      >
                        <S.CardHeader>
                          <H6 color={theme.colors.gray.Cinza_2}>
                            {item.title}
                          </H6>

                          <S.CropBadge>
                            <S.Bullet status={item.agro_task_status?.id} />

                            <TaglineP
                              color={theme.colors.gray.Cinza_2}
                              fontWeight={800}
                            >
                              {item.agro_task_status?.descricao}
                            </TaglineP>
                          </S.CropBadge>
                        </S.CardHeader>

                        <S.Description>
                          <BodyP color={theme.colors.gray.Cinza_2}>
                            {item.description}
                          </BodyP>

                          <S.BulletProfile>
                            <Auxiliar
                              color={theme.colors.white.Branco}
                              fontWeight={700}
                            >
                              {item.agro_agronomists?.nome
                                .split(" ")
                                .filter((name) => name.length > 0)
                                .map((word, index, array) =>
                                  array.length === 1
                                    ? word.substring(0, 2)
                                    : index < 2
                                    ? word[0]
                                    : ""
                                )
                                .join("")
                                .toUpperCase()}
                            </Auxiliar>
                          </S.BulletProfile>
                        </S.Description>

                        {item.agro_farms?.nome ||
                        item.agro_cultures?.nome_comum ? (
                          <S.ContainerCultureAndLocalization>
                            {item.agro_farms?.nome && (
                                <S.Localization>
                                  <img src={local} alt="Localização" style={{ width: "16px", height: "16px" }} />

                                  <TaglineP
                                    color={theme.colors.blue.Azul_link}
                                    fontWeight={800}
                                  >
                                    {item.agro_farms?.nome}
                                  </TaglineP>
                                </S.Localization>
                            )}

                            {item.agro_cultures?.nome_comum && (
                              <S.BulletCulture
                                style={{ cursor: "pointer" }}
                                onClick={(e) => { e.stopPropagation(); openCulturaUrl(item.agro_cultures.nome_comum, item.agro_cultures.nome_cientifico); }}
                              >
                                <TaglineP
                                  color={theme.colors.white.Branco}
                                  fontWeight={800}
                                >
                                  {item.agro_cultures?.nome_comum}
                                </TaglineP>
                              </S.BulletCulture>
                            )}
                          </S.ContainerCultureAndLocalization>
                        ) : null}

                        <S.DateAndContact>
                          <TaglineP
                            color={theme.colors.gray.Cinza_2}
                            fontWeight={600}
                          >
                            {formatarData(item.date_begin)}
                          </TaglineP>

                          <S.Contact hasProducer={!!item.agro_producers?.nome}>
                            {item.agro_producers?.nome ? (
                              <>
                              <Tooltip 
                                  content={"Telefone: " + formatTelefone(item.agro_producers?.telefone)} 
                                  placement="top"
                                  animation="fade"
                                  delay={[0, 100]}
                                  arrow
                                  theme="light"
                                  disabled={!item.agro_producers?.telefone}
                                  >
                                <a
                                  href={`tel:+55${formatPhoneNumber(item.agro_producers?.telefone)}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    cursor: !item.agro_producers?.telefone
                                      ? "not-allowed"
                                      : "pointer",
                                  }}
                                  onClick={async (e) => {
                                    if (!item.agro_producers?.telefone) {
                                      e.preventDefault();
                                      return;
                                    }

                                    if (!isMobileDevice()) {
                                      e.preventDefault();
                                      const ok = await copyTextToClipboard(
                                        formatTelefone(item.agro_producers?.telefone)
                                      );
                                      if (ok) notifyPhoneCopied();
                                    }
                                  }}
                                >
                                  <img
                                    src={IconPhone}
                                    alt="ícone de telefone"
                                    style={{
                                      opacity: !item.agro_producers?.telefone
                                        ? 0.5
                                        : 1,
                                    }}
                                  />
                                </a>
                                </Tooltip>

                                {item.agro_producers?.telefone ? (
                                  <Tooltip
                                    content={"WhatsApp: " + formatTelefone(item.agro_producers?.telefone)}
                                    placement="top"
                                    animation="fade"
                                    delay={[0, 100]}
                                    arrow
                                    theme="light"
                                  >
                                    <a
                                      href={`https://wa.me/55${formatPhoneNumber(
                                        item.agro_producers?.telefone
                                      )}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img src={IconZap} alt="ícone de whatsapp" />
                                    </a>
                                  </Tooltip>
                                ) : (
                                  <a
                                    href="#"
                                    style={{ cursor: "not-allowed" }}
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    <img
                                      src={IconZap}
                                      alt="ícone de whatsapp"
                                      style={{ opacity: 0.5 }}
                                    />
                                  </a>
                                )}

                                {(() => {
                                  const { href, disabled } = getMapLink(item);
                                  const mapIcon = (
                                    <a
                                      href={href || undefined}
                                      target={href ? "_blank" : undefined}
                                      rel={href ? "noopener noreferrer" : undefined}
                                      style={{
                                        cursor: disabled ? "not-allowed" : "pointer",
                                        opacity: disabled ? 0.5 : 1,
                                      }}
                                      onClick={(e) => {
                                        if (disabled || !href) e.preventDefault();
                                      }}
                                    >
                                      <img
                                        src={IconMap}
                                        alt="Abrir no mapa"
                                        style={{ filter: "brightness(0) saturate(100%)" }}
                                      />
                                    </a>
                                  );

                                  if (disabled) return mapIcon;

                                  return (
                                    <Tooltip
                                      content="Abrir no mapa"
                                      placement="top"
                                      animation="fade"
                                      delay={[0, 100]}
                                      arrow
                                      theme="light"
                                    >
                                      {mapIcon}
                                    </Tooltip>
                                  );
                                })()}
                            </>
                          ) : (
                            <>
                                {item.agro_producers?.email ? (
                                  <Tooltip
                                    content={"E-mail: " + item.agro_producers?.email}
                                    placement="top"
                                    animation="fade"
                                    delay={[0, 100]}
                                    arrow
                                    theme="light"
                                  >
                                    <a
                                      href={`mailto:${item.agro_producers?.email}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img src={IconEmail} alt="ícone de email" />
                                    </a>
                                  </Tooltip>
                                ) : (
                                  null
                                )
                                }
                              </>
                            )}

                            {item.agro_producers?.nome && (
                              <S.BulletProfileContact>
                                <Auxiliar
                                  color={theme.colors.white.Branco}
                                  fontWeight={700}
                                >
                                  {item.agro_producers?.nome
                                    .split(" ")
                                    .filter((name) => name.length > 0)
                                    .map((word, index, array) =>
                                      array.length === 1
                                        ? word.substring(0, 2)
                                        : index < 2
                                        ? word[0]
                                        : ""
                                    )
                                    .join("")
                                    .toUpperCase()}
                                </Auxiliar>
                              </S.BulletProfileContact>
                            )}
                          </S.Contact>
                        </S.DateAndContact>
                      </S.Card>
                    ))}

                  {isLoadingResume === false && consult.data?.length === 0 && (
                    <S.ContainerItemNotFound>
                      <img src={ItemNotFound} alt="" />

                      <H6 color={theme.colors.gray.Cinza_2}>
                        Nenhum item encontrado!
                      </H6>
                    </S.ContainerItemNotFound>
                  )}
                </S.ContainerCards>
              )}
            </S.ContentOfSearch>
          </S.Content>
        </S.ContainerContent>

        <ModalCreateOrEditEvent
          open={showNewEvent}
          onOpenChange={(e) => {
            setShowNewEvent(e);
            if (!e) {
              clearFields();
              setIsEdit(false);
              setEventCoords(null);
            }
          }}
          isEdit={isEdit}
          onDelete={() => showDeleteConfirmation()}
          styles={S}
          responsavelTecnicoValue={responsavelTecnicoSelecionado ? responsavelTecnicoSelecionado.value : ""}
          onResponsavelTecnicoChange={(selectedOption) => {
            setResponsavelTecnicoSelecionado(selectedOption);
            setAgronomistError(false);
          }}
          agronomists={agronomists}
          agronomistError={agronomistError}
          onAddAgronomist={() => setShowAddAgronomist(true)}
          produtorValue={produtorSelecionado ? produtorSelecionado.value : ""}
          onProdutorChange={(selectedOption) => {
            setProdutorSelecionado(selectedOption);
            if (!renderFarm && selectedOption.value) {
              getAgroFarms(selectedOption.value);
              setIdProducer(selectedOption.value);
            }
            if (!selectedOption.value) {
              setFazendaSelecionada(null);
            }
            setProducerError(false);
          }}
          producers={producers}
          producerError={producerError}
          onAddProducer={() => setShowAddProducer(true)}
          fazendaValue={fazendaSelecionada ? fazendaSelecionada.value : ""}
          onFazendaChange={(selectedOption) => {
            setFazendaSelecionada(selectedOption);
            setFarmError(false);
          }}
          agroFarms={agroFarms}
          farmError={farmError}
          isFarmDisabled={isFarmDisabled}
          isButtonFarmDisabled={isButtonFarmDisabled}
          onAddFarm={() => setShowAddFarm(true)}
          titleValue={titleDrawer}
          onTitleChange={(e) => {
            setTitleDrawer(e.target.value);
            if (e.target.value.trim()) setTitleError(false);
          }}
          titleError={titleError}
          descriptionValue={descriptionDrawer}
          onDescriptionChange={(e) => {
            setDescriptionDrawer(e.target.value);
            if (e.target.value.trim()) setDescriptionError(false);
          }}
          descriptionError={descriptionError}
          culturaValue={culturaSelecionada ? culturaSelecionada.value : ""}
          onCulturaChange={(selectedOption) => {
            setCulturaSelecionada({
              value: selectedOption.value,
              label: selectedOption.label,
            });
            setCultureError(false);
          }}
          cultures={cultures}
          cultureError={cultureError}
          startDateValue={startDateDrawer}
          onStartDateChange={(e) => {
            setStartDateDrawer(e.target.value);
            if (e.target.value) setStartDateError(false);
          }}
          startDateError={startDateError}
          endDateValue={endDateDrawer}
          onEndDateChange={(e) => {
            setEndDateDrawer(e.target.value);
            if (e.target.value) setEndDateError(false);
          }}
          endDateError={endDateError}
          statusRef={selectStatusRef}
          statusValue={statusDrawer.value ? statusDrawer : null}
          onStatusChange={(selectedOption) => {
            setStatusDrawer({
              value: selectedOption.value,
              label: selectedOption.label,
            });
            setStatusError(false);
          }}
          statusError={statusError}
          statusFloatingValue={statusDrawer.label}
          mapCoords={eventCoords}
          buildMapUrl={buildMeteoblueUrl}
          commentResourceId={isEdit ? currentId : 0}
          onSave={isEdit ? handleEditEvent : handleSaveEvent}
          isLoading={isLoading}
        />

        <Modal
          show={showAddAgronomist}
          size="sm"
          onHide={() => {
            setShowAddAgronomist(false);
          }}
          zIndex={1200}
        >
          <S.ContainerModalAddAgronomist>
            <BodyM fontWeight={800}>Cadastre um novo responsável técnico</BodyM>

            <InputV3
              id="nome"
              type="text"
              floatingLabelWithAsterisk="Nome do responsável técnico"
              value={nameAgronomist}
              onChange={(e) => {
                setNameAgronomist(e.target.value);

                if (hasErrorAgronomist.name) {
                  setHasErrorAgronomist({ ...hasErrorAgronomist, name: false });
                }
              }}
              hasError={hasErrorAgronomist.name}
            />

            <InputV3
              id="email"
              type="text"
              label="E-mail"
              floatingLabelWithAsterisk="E-mail"
              value={emailAgronomist}
              onChange={(e) => {
                setEmailAgronomist(e.target.value);

                if (hasErrorAgronomist.email) {
                  setHasErrorAgronomist({
                    ...hasErrorAgronomist,
                    email: false,
                  });
                }
              }}
              hasError={hasErrorAgronomist.email}
            />

            <InputV3
              id="cpf"
              type="text"
              floatingLabelWithAsterisk="CPF"
              value={formatCPF(cpfAgronomist)}
              onChange={(e) => {
                const rawValue = e.target.value.replace(/\D/g, "").slice(0, 11);
                setCpfAgronomist(rawValue);

                if (hasErrorAgronomist.cpf) {
                  setHasErrorAgronomist({ ...hasErrorAgronomist, cpf: false });
                }
              }}
              onBlur={handleBlurCpfAgronomist}
              onKeyDown={(e) => {
                if (
                  !/[0-9]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)
                ) {
                  e.preventDefault();
                }
              }}
              hasError={hasErrorAgronomist.cpf}
              errorInfo={cpfAgronomistErrorMsg}
              maxLength={14}
            />

            <InputV3
              id="Telefone/Celular"
              type="telefone/celular"
              label="Telefone/Celular"
              floatingLabel="Whatsapp"
              value={whatsappAgronomist}
              onChange={(e) => {
                setWhatsappAgronomist(e.target.value);

                if (hasErrorAgronomist.whatsapp) {
                  setHasErrorAgronomist({
                    ...hasErrorAgronomist,
                    whatsapp: false,
                  });
                }
              }}
              hasError={hasErrorAgronomist.whatsapp}
            />

            <div className="radios" style={{ display: "flex", gap: "5px" }}>
              <input
                type="radio"
                id="m"
                name="fav_language"
                value="M"
                onChange={(e) => tipoAssinatura(e.target.value)}
              ></input>
              <label for="m">Assinatura Manual</label>
              <input
                type="radio"
                id="d"
                name="fav_language"
                value="D"
                onChange={(e) => tipoAssinatura(e.target.value)}
              ></input>
              <label for="d">Assinatura Digital</label>
              <input
                type="radio"
                id="e"
                name="fav_language"
                value="E"
                onChange={(e) => tipoAssinatura(e.target.value)}
              ></input>
              <label for="e">Assinatura Eletrônica</label>
            </div>

            {digital ? (
              <>
                <S.Assinaturas>
                  Assinatura Digital é aquela que precisa de um certificado A1
                  válido. {estadosDigital.length > 0 ? `Aceita em todos os estados brasileiros, exceto ${estadosDigital.join(', ')}.` : 'Aceita em todos os estados brasileiros.'}
                </S.Assinaturas>
                <div class="input-wrapper">
                  <label
                    style={{
                      paddingLeft: "15px",
                      textAlign: "left",
                      fontSize: "12px",
                      fontWeight: 700,
                      color: "#8a92a2",
                    }}
                  >
                    Upload certificado digital
                  </label>
                  <div className="arquivos">
                    <label
                      className="btn-update"
                      for="input-file"
                      multiple
                      onClick={() => {
                        setRenderInput(true);
                      }}
                    >
                      <IconUploads
                        width="auto"
                        height="40px"
                        marginBottom="100px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      />
                      Selecione o arquivo PFX em seu computador.<br></br>
                      <br></br>O upload do certificado é necessário caso deseje
                      assinar sua receita digitalmente.{" "}
                      <label className="arq-name">
                        {namesfiles.length > 0 ? (
                          <>
                            {namesfiles}
                            <img
                              src={mais}
                              width="20"
                              height="20"
                              onClick={() => deleteFile()}
                              alt="Mais"
                            />
                          </>
                        ) : (
                          "Nenhum arquivo selecionado"
                        )}{" "}
                      </label>
                    </label>
                  </div>

                  {renderInput ? (
                    <input
                      style={{ display: "none" }}
                      type="file"
                      id="input-file"
                      name="file"
                      multiple
                      onChange={(e) => onChangeCertificate(e)}
                    />
                  ) : null}
                </div>
              </>
            ) : eletronica ? (
              <>
                <S.Assinaturas>
                  Assinatura Eletrônica é aquela que utiliza um conjunto de
                  dados digitais para validação. {excecoesEletronica.length > 0 ? `Aceita em todos os estados brasileiros, exceto ${excecoesEletronica.join(', ')}.` : 'Aceita em todos os estados brasileiros.'}
                </S.Assinaturas>
                <InputSign sign={assinatura} update={(e) => editSign(e)} />
              </>
            ) : manual ? (
              <>
                <S.Assinaturas>
                  Assinatura Manual é aquela onde você assina à próprio punho.
                  Aceita em todos os estados brasileiros.
                </S.Assinaturas>
              </>
            ) : null}

            <S.ContainerButtonsModal>
              <S.ButtonCancelModal onClick={() => setShowAddAgronomist(false)}>
                <TaglineM
                  fontWeight={theme.typography.fontWeight.extraBold}
                  color={theme.colors.green.Verde_AgroReceita}
                >
                  Cancelar
                </TaglineM>
              </S.ButtonCancelModal>

              <S.ButtonSavedModal onClick={() => handleCreateAgronomist()}>
                <TaglineM
                  fontWeight={theme.typography.fontWeight.extraBold}
                  color={theme.colors.white.Branco}
                >
                  {isLoadingSavedAgronomist ? <S.Loading /> : "Salvar"}
                </TaglineM>
              </S.ButtonSavedModal>
            </S.ContainerButtonsModal>
          </S.ContainerModalAddAgronomist>
        </Modal>

        <Modal
          show={showAddProducer}
          size="sm"
          onHide={() => {
            setShowAddProducer(false);

            clearFieldsProducer();
          }}
        >
          <S.ContainerModalAddProducer>
            <BodyM fontWeight={800}>Cadastre um novo produtor</BodyM>

            <InputV3
              type="text"
              floatingLabelWithAsterisk="Nome do produtor"
              value={nameProducer}
              onChange={(e) => {
                setNameProducer(e.target.value);

                if (hasErrorProducer.nameProducer) {
                  setHasErrorProducer({
                    ...hasErrorProducer,
                    nameProducer: false,
                  });
                }
              }}
              hasError={hasErrorProducer.nameProducer}
            />

            <InputV3
              type="text"
              floatingLabelWithAsterisk="E-mail"
              value={emailProducer}
              onChange={(e) => {
                setEmailProducer(e.target.value);

                if (hasErrorProducer.emailProducer) {
                  setHasErrorProducer({
                    ...hasErrorProducer,
                    emailProducer: false,
                  });
                }
              }}
              hasError={hasErrorProducer.emailProducer}
            />

            <InputV3
              type="text"
              floatingLabelWithAsterisk="CPF/CNPJ"
              value={formatCPFOrCNPJ(cpfCnpjProducer)}
              onChange={(e) => {
                const rawValue = e.target.value.replace(/\D/g, "");
                setCpfCnpjProducer(rawValue);

                if (hasErrorProducer.cpfCnpjProducer) {
                  setHasErrorProducer({
                    ...hasErrorProducer,
                    cpfCnpjProducer: false,
                  });
                }
              }}
              onKeyDown={(e) => {
                if (
                  !/[0-9]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)
                ) {
                  e.preventDefault();
                }
              }}
              onBlur={handleBlurCpfCnpjProducer}
              inputMode="numeric"
              maxLength={18}
              hasError={hasErrorProducer.cpfCnpjProducer}
              errorInfo={cpfCnpjProducerErrorMsg}
            />

            <InputV3
              id="telefone/celular"
              type="telefone/celular"
              label="Telefone/Celular"
              floatingLabelWithAsterisk="Telefone"
              value={telephoneProducer}
              onChange={(e) => {
                setTelephoneProducer(e.target.value);

                if (hasErrorProducer.telephoneProducer) {
                  setHasErrorProducer({
                    ...hasErrorProducer,
                    telephoneProducer: false,
                  });
                }
              }}
              hasError={hasErrorProducer.telephoneProducer}
            />

            <InputV3
              id="telefone/celular"
              type="telefone/celular"
              label="Telefone/Celular"
              floatingLabel="Celular"
              value={cellphoneProducer}
              onChange={(e) => {
                setCellphoneProducer(e.target.value);

                if (hasErrorProducer.cellphoneProducer) {
                  setHasErrorProducer({
                    ...hasErrorProducer,
                    cellphoneProducer: false,
                  });
                }
              }}
              hasError={hasErrorProducer.cellphoneProducer}
            />

            <InputV3
              id="cep"
              type="text"
              label="CEP"
              floatingLabelWithAsterisk="CEP"
              value={formatCEP(cepProducer)}
              onChange={(e) => {
                const rawValue = e.target.value.replace(/\D/g, "");
                setCepProducer(rawValue);

                if (hasErrorProducer.cepProducer) {
                  setHasErrorProducer({
                    ...hasErrorProducer,
                    cepProducer: false,
                  });
                }
              }}
              onBlur={() => {
                if (validateCEP(cepProducer)) {
                  fetchCep(cepProducer, "produtor");
                }
              }}
              maxLength={9}
              inputMode="numeric"
              onKeyDown={(e) => {
                if (
                  !/[0-9]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)
                ) {
                  e.preventDefault();
                }
              }}
              hasError={hasErrorProducer.cepProducer}
            />

            <InputV3
              type="text"
              floatingLabelWithAsterisk="Logradouro"
              value={logradouroProducer}
              onChange={(e) => {
                setLogradouroProducer(e.target.value);

                if (hasErrorProducer.logradouroProducer) {
                  setHasErrorProducer({
                    ...hasErrorProducer,
                    logradouroProducer: false,
                  });
                }
              }}
              hasError={hasErrorProducer.logradouroProducer}
            />

            <InputV3
              id="bairro"
              type="text"
              label="Bairro"
              floatingLabelWithAsterisk="Bairro"
              value={bairroProducer}
              onChange={(e) => {
                setBairroProducer(e.target.value);

                if (hasErrorProducer.bairroProducer) {
                  setHasErrorProducer({
                    ...hasErrorProducer,
                    bairroProducer: false,
                  });
                }
              }}
              hasError={hasErrorProducer.bairroProducer}
            />

            <InputV3
              id="numero"
              type="number"
              label="Número"
              floatingLabelWithAsterisk="Número"
              value={numberProducer}
              onChange={(e) => {
                setNumberProducer(e.target.value);

                if (hasErrorProducer.numberProducer) {
                  setHasErrorProducer({
                    ...hasErrorProducer,
                    numberProducer: false,
                  });
                }
              }}
              hasError={hasErrorProducer.numberProducer}
            />

            <InputV3
              id="complemento"
              type="text"
              label="Complemento"
              floatingLabel="Complemento"
              value={complementProducer}
              onChange={(e) => {
                setComplementProducer(e.target.value);

                if (hasErrorProducer.complementProducer) {
                  setHasErrorProducer({
                    ...hasErrorProducer,
                    complementProducer: false,
                  });
                }
              }}
              hasError={hasErrorProducer.complementProducer}
            />

            <InputV3
              id="cidade"
              type="text"
              label="Cidade"
              floatingLabelWithAsterisk="Cidade"
              value={cityProducer}
              onChange={(e) => {
                setCityProducer(e.target.value);

                if (hasErrorProducer.cityProducer) {
                  setHasErrorProducer({
                    ...hasErrorProducer,
                    cityProducer: false,
                  });
                }
              }}
              hasError={hasErrorProducer.cityProducer}
            />

            <InputV3
              ref={selectStateProducerRef}
              type="select"
              floatingLabelWithAsterisk="Estado"
              value={stateProducer ? stateProducer.label : stateProducer.value}
              onChange={(selectedOption) => {
                setStateProducer({
                  value: selectedOption.value,
                  label: selectedOption.label,
                });

                if (hasErrorProducer.stateProducer) {
                  setHasErrorProducer({
                    ...hasErrorProducer,
                    stateProducer: false,
                  });
                }
              }}
              options={stateOptions}
              hasError={hasErrorProducer.stateProducer}
              floatingValue={stateProducer.label}
            />

            <S.ContainerButtonsModal>
              <S.ButtonCancelModal onClick={() => setShowAddProducer(false)}>
                <TaglineM
                  fontWeight={theme.typography.fontWeight.extraBold}
                  color={theme.colors.green.Verde_AgroReceita}
                >
                  Cancelar
                </TaglineM>
              </S.ButtonCancelModal>

              <S.ButtonSavedModal onClick={() => handleCreateProducer()}>
                <TaglineM
                  fontWeight={theme.typography.fontWeight.extraBold}
                  color={theme.colors.white.Branco}
                >
                  {isLoadingSavedProducer ? <S.Loading /> : "Salvar"}
                </TaglineM>
              </S.ButtonSavedModal>
            </S.ContainerButtonsModal>
          </S.ContainerModalAddProducer>
        </Modal>

        <Modal
          show={showAddFarm}
          size="sm"
          onHide={() => {
            setShowAddFarm(false);

            clearFieldsFarm();
          }}
        >
          <S.ContainerModalAddFarm>
            <BodyM fontWeight={800}>Cadastre um novo local de aplicação</BodyM>

            <InputV3
              type="text"
              floatingLabelWithAsterisk="Nome da fazenda"
              value={nameFarm}
              onChange={(e) => {
                setNameFarm(e.target.value);

                if (hasErrorFarm.nameFarm) {
                  setHasErrorFarm({
                    ...hasErrorFarm,
                    nameFarm: false,
                  });
                }
              }}
              hasError={hasErrorFarm.nameFarm}
            />

            <InputV3
              type="text"
              floatingLabelWithAsterisk="CPF/CNPJ"
              value={formatCPFOrCNPJ(cpfCnpjFarm)}
              onChange={(e) => {
                setCpfCnpjFarm(e.target.value);

                if (hasErrorFarm.cpfCnpjFarm) {
                  setHasErrorFarm({
                    ...hasErrorFarm,
                    cpfCnpjFarm: false,
                  });
                }
              }}
              onKeyDown={(e) => {
                if (
                  !/[0-9]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)
                ) {
                  e.preventDefault();
                }
              }}
              onBlur={handleBlurCpfCnpjFarm}
              inputMode="numeric"
              maxLength={18}
              hasError={hasErrorFarm.cpfCnpjFarm}
              errorInfo={cpfCnpjFarmErrorMsg}
            />

            <InputV3
              type="text"
              floatingLabel="Inscrição Estadual"
              value={registrationStateFarm}
              onChange={(e) => {
                setRegistrationStateFarm(e.target.value);
              }}
              hasError={hasErrorFarm.registrationStateFarm}
            />

            <InputV3
              type="text"
              floatingLabelWithAsterisk="CEP"
              value={formatCEP(cepFarm)}
              onChange={(e) => {
                setCepFarm(e.target.value);

                if (hasErrorFarm.cepFarm) {
                  setHasErrorFarm({
                    ...hasErrorFarm,
                    cepFarm: false,
                  });
                }
              }}
              onBlur={() => {
                if (validateCEP(cepFarm)) {
                  fetchCep(cepFarm, "fazenda");
                }
              }}
              maxLength={9}
              inputMode="numeric"
              onKeyDown={(e) => {
                if (
                  !/[0-9]|Backspace|Delete|Tab|ArrowLeft|ArrowRight/.test(e.key)
                ) {
                  e.preventDefault();
                }
              }}
              hasError={hasErrorFarm.cepFarm}
            />

            <InputV3
              type="text"
              floatingLabelWithAsterisk="Logradouro"
              value={logradouroFarm}
              onChange={(e) => {
                setLogradouroFarm(e.target.value);

                if (hasErrorFarm.logradouroFarm) {
                  setHasErrorFarm({
                    ...hasErrorFarm,
                    logradouroFarm: false,
                  });
                }
              }}
              hasError={hasErrorFarm.logradouroFarm}
            />

            <InputV3
              type="text"
              floatingLabelWithAsterisk="Bairro"
              value={bairroFarm}
              onChange={(e) => {
                setBairroFarm(e.target.value);

                if (hasErrorFarm.bairroFarm) {
                  setHasErrorFarm({
                    ...hasErrorFarm,
                    bairroFarm: false,
                  });
                }
              }}
              hasError={hasErrorFarm.bairroFarm}
            />

            <InputV3
              id="numero"
              type="number"
              label="Número"
              floatingLabelWithAsterisk="Número"
              value={numberFarm}
              onChange={(e) => {
                setNumberFarm(e.target.value);

                if (hasErrorFarm.numberFarm) {
                  setHasErrorFarm({ ...hasErrorFarm, numberFarm: false });
                }
              }}
              hasError={hasErrorFarm.numberFarm}
            />

            <InputV3
              type="text"
              floatingLabel="Complemento"
              value={complementFarm}
              onChange={(e) => {
                setComplementFarm(e.target.value);
              }}
              hasError={hasErrorFarm.complementFarm}
            />

            <InputV3
              id="numero"
              type="number"
              label="Número"
              floatingLabelWithAsterisk="Código IBGE"
              value={codeIbgeFarm}
              onChange={(e) => {
                setCodeIbgeFarm(e.target.value);

                if (hasErrorFarm.codeIbgeFarm) {
                  setHasErrorFarm({
                    ...hasErrorFarm,
                    codeIbgeFarm: false,
                  });
                }
              }}
              hasError={hasErrorFarm.codeIbgeFarm}
            />

            <InputV3
              type="text"
              floatingLabelWithAsterisk="Cidade"
              value={cityFarm}
              onChange={(e) => {
                setCityFarm(e.target.value);

                if (hasErrorFarm.cityFarm) {
                  setHasErrorFarm({
                    ...hasErrorFarm,
                    cityFarm: false,
                  });
                }
              }}
              hasError={hasErrorFarm.cityFarm}
            />

            <InputV3
              ref={selectStateFarmRef}
              type="select"
              floatingLabelWithAsterisk="Estado"
              value={stateFarm.value ? stateFarm : null}
              onChange={(selectedOption) => {
                setStateFarm({
                  value: selectedOption.value,
                  label: selectedOption.label,
                });

               setEstadoLocal(selectedOption.value);

                if (hasErrorFarm.stateFarm) {
                  setHasErrorFarm({
                    ...hasErrorFarm,
                    stateFarm: false,
                  });
                }
              }}
              options={stateOptions}
              hasError={hasErrorFarm.stateFarm}
              floatingValue={stateFarm.label}
            />

            <InputV3
              type="text"
              floatingLabel="Número de inscrição do produtor ao órgão estadual"
              value={producersRegistrationNumberAgencyFarm}
              onChange={(e) => {
                setProducersRegistrationNumberAgencyFarm(e.target.value);
              }}
              hasError={false}
            />

            <InputV3
              type="text"
              floatingLabel="Área Total (ha)"
              value={totalAreaFarm}
              onChange={(e) => {
                setTotalAreaFarm(e.target.value);
              }}
              hasError={false}
            />

            <InputV3
              type="text"
              floatingLabel="Culturas"
              value={culturesFarm}
              onChange={(e) => {
                setCulturesFarm(e.target.value);
              }}
              hasError={false}
            />

            <InputV3
              type="text"
              floatingLabel="Cadastro Ambiental Rural"
              value={registrationAmbientFarm}
              onChange={(e) => {
                setRegistrationAmbientFarm(e.target.value);
              }}
              hasError={false}
            />

            <InputV3
              ref={selectCoordinatesFarmRef}
              type="select"
              floatingLabel={isEstadoObrigatorio(estadoLocal) ? "" : "Selecionar coordenadas geográficas"}
              floatingLabelWithAsterisk={isEstadoObrigatorio(estadoLocal) ? "Selecionar coordenadas geográficas" : ""} 
              value={
                optionsCoordinatesFarm.label ? optionsCoordinatesFarm : null
              }
              onChange={(selectedOption) => {
                setOptionsCoordinatesFarm({
                  value: selectedOption.value,
                  label: selectedOption.label,
                });
                changeModoCoord(selectedOption.value);

                if (hasErrorFarm.geographicCoordinate) {
                  setHasErrorFarm({
                    ...hasErrorFarm,
                    geographicCoordinate: false,
                  });
                }
              }}
              options={[
                { value: 1, label: "Selecionar no mapa" },
                { value: 2, label: "Digitar coordenadas" },
              ]}
              hasError={hasErrorFarm.geographicCoordinate}
            />

            {showMapa ? (
              <MapaArea
                label="Selecione o local de aplicação"
                endereco={[logradouroFarm, numberFarm, bairroFarm, cityFarm, estadoLocal, formatCEP(cepFarm)].filter(Boolean).join(', ')}
                onChange={(lat, lgt) => changeCoordinates(lat, lgt)}
              />
            ) : showInputs ? (
              <>
                <label className="labelcoord">
                  {isEstadoObrigatorio(estadoLocal)
                    ? "Latitude (Obrigatório)"
                    : "Latitude"}
                </label>
                <S.ContainerInputCoordinatesFarm>
                  <S.CoordinatesFarm>
                    <Input
                      label="Graus"
                      name="latatitude"
                      className="input"
                      id="lgraus"
                      value={latitudeGraus}
                      maxLength={2}
                      onChange={(e) => validateLatitude(1, e)}
                      erro={erroLatitude}
                      inputmode="numeric"
                    />
                    <span>°</span>
                  </S.CoordinatesFarm>

                  <S.CoordinatesFarm>
                    <Input
                      label="Minutos"
                      name="latatitude"
                      className="input"
                      id="lminutos"
                      value={latitudeMinutos}
                      maxLength={2}
                      onChange={(e) => validateLatitude(2, e)}
                      style={{ marginTop: "16px" }}
                      erro={erroLatitude}
                      inputmode="numeric"
                    />
                    <span>'</span>
                  </S.CoordinatesFarm>

                  <S.CoordinatesFarm>
                    <Input
                      label="Segundos"
                      name="latatitude"
                      className="input"
                      id="lsegundos"
                      value={latitudeSegundos}
                      maxLength={4}
                      onChange={(e) => validateLatitude(3, e)}
                      style={{ marginTop: "16px" }}
                      erro={erroLatitude}
                      inputmode="numeric"
                    />
                    <span>"S</span>
                  </S.CoordinatesFarm>
                </S.ContainerInputCoordinatesFarm>

                <label className="labelcoord">
                  {isEstadoObrigatorio(estadoLocal)
                    ? "Longitude (Obrigatório)"
                    : "Longitude"}
                </label>
                <S.ContainerInputCoordinatesFarm>
                  <S.CoordinatesFarm>
                    <Input
                      label="Graus"
                      name="longitude"
                      className="input"
                      id="longrau"
                      value={longitudeGraus}
                      maxLength={2}
                      onChange={(e) => validateLongitude(1, e)}
                      erro={erroLongitude}
                      inputmode="numeric"
                    />
                    <span>°</span>
                  </S.CoordinatesFarm>

                  <S.CoordinatesFarm>
                    <Input
                      label="Minutos"
                      name="longitude"
                      className="input"
                      id="lonminutos"
                      value={longitudeMinutos}
                      maxLength={2}
                      onChange={(e) => validateLongitude(2, e)}
                      style={{ marginTop: "16px" }}
                      erro={erroLongitude}
                      inputmode="numeric"
                    />
                    <span>'</span>
                  </S.CoordinatesFarm>

                  <S.CoordinatesFarm>
                    <Input
                      label="Segundos"
                      name="longitude"
                      className="input"
                      id="lonsegundos"
                      value={longitudeSegundos}
                      maxLength={4}
                      onChange={(e) => validateLongitude(3, e)}
                      style={{ marginTop: "16px" }}
                      erro={erroLongitude}
                      inputmode="numeric"
                    />
                    <span>"W</span>
                  </S.CoordinatesFarm>
                </S.ContainerInputCoordinatesFarm>
              </>
            ) : (
              <></>
            )}

            <S.ContainerButtonsModal>
              <S.ButtonCancelModal onClick={() => setShowAddProducer(false)}>
                <TaglineM
                  fontWeight={theme.typography.fontWeight.extraBold}
                  color={theme.colors.green.Verde_AgroReceita}
                >
                  Cancelar
                </TaglineM>
              </S.ButtonCancelModal>

              <S.ButtonSavedModal onClick={() => handleCreateFarm()}>
                <TaglineM
                  fontWeight={theme.typography.fontWeight.extraBold}
                  color={theme.colors.white.Branco}
                >
                  {isLoadingSavedFarm ? <S.Loading /> : "Salvar"}
                </TaglineM>
              </S.ButtonSavedModal>
            </S.ContainerButtonsModal>
          </S.ContainerModalAddFarm>
        </Modal>

        {shouldShowFilter && (
          <Modal
            show={showFilters}
            size="sm"
            onHide={() => {
              setShowFilters(false);
            }}
          >
            <FilterV2
              filterOptions={options}
              onBlurFilter={consultEvent}
              startDateValue={startDateFilter}
              endDateValue={endDateFilter}
            >
              <S.ContainerFilterChindren>
                <InputV3
                  id="datetime-start"
                  type="date"
                  label="Selecione Data de início"
                  floatingLabelWithAsterisk="Data de início"
                  value={startDateFilter}
                  min="2000-01-01"
                  max="2100-12-31"
                  onChange={(e) => {
                    setStartDateFilter(e.target.value);
                  }}
                  onBlur={() => {
                    validarDatasEConsultar();
                  }}
                  handleClear={() => {
                    setStartDateFilter("");
                    validarDatasEConsultar();
                  }}
                />

                <InputV3
                  id="datetime-end"
                  type="date"
                  label="Selecione Data de término"
                  floatingLabelWithAsterisk="Data de término"
                  value={endDateFilter}
                  min="2000-01-01"
                  max="2100-12-31"
                  onChange={(e) => {
                    setEndDateFilter(e.target.value);
                  }}
                  onBlur={() => {
                    validarDatasEConsultar();
                  }}
                  handleClear={() => {
                    setEndDateFilter("");
                    validarDatasEConsultar();
                  }}
                />
              </S.ContainerFilterChindren>
            </FilterV2>
          </Modal>
        )}

        {openModalTrue ? (
          <ModalBlock show={openModalTrue} onHide={() => {window.location.href = "/" ; setOpenModalTrue(false)}} />
        ) : null}

        <ModalYesNo
          show={showDeleteConfirmModal}
          onHide={() => setShowDeleteConfirmModal(false)}
          title="Confirmar exclusão"
          text="Tem certeza que deseja excluir este evento? Esta ação não pode ser desfeita."
          btnNo={true}
          update={(response) => handleDeleteConfirmation(response)}
        />
      </S.Wrapper>
    </S.Container>
  );
}
